{
  "unavailable": {
    "requestTitle": "Richiesta non disponibile",
    "requestDescription": "Questa richiesta non è più disponibile. Potrebbe essere stata eliminata o il collegamento potrebbe essere errato.",
    "requestAction": "Vai alle mie richieste",
    "budgetTitle": "Preventivo non disponibile",
    "budgetDescription": "Questo preventivo non è più disponibile. Potrebbe essere stato eliminato o il collegamento potrebbe essere errato.",
    "budgetAction": "Vai ai preventivi"
  },
  "identityCandidates": {
    "title": "Alternative proposte da Atlas",
    "choose": "Seleziona questo prodotto",
    "searchLabel": "Codice, riferimento, marca o testo visibile",
    "search": "Cerca con Atlas",
    "reviewPending": "Atlas non è riuscito a identificare il prodotto da ciò che ha letto nel documento. Occorre correggere codice, riferimento, marca o descrizione come compaiono nel documento.",
    "pendingTitle": "Identificazione in corso",
    "identityPending": "Atlas non ha ancora pubblicato il passaggio successivo per identificare questo prodotto.",
    "readValues": "Ciò che Atlas ha letto nel documento:",
    "askAgainHint": "Interroga di nuovo Atlas per aprire il modulo e continuare.",
    "askAgain": "Interroga di nuovo Atlas",
    "correctTitle": "Correggi la lettura",
    "correctHint": "Correggi solo i dati visibili nel documento. Atlas cercherà nuovamente senza modificare quantità e unità.",
    "confirmCorrection": "Conferma correzione",
    "fields": {
      "source_code": "Codice letto",
      "source_reference": "Riferimento letto",
      "source_brand": "Marca letta",
      "source_description": "Descrizione letta",
      "raw_text": "Testo completo letto"
    },
    "selecting": "Selezione in corso…"
  },
  "documentQuantity": {
    "commercialPending": "Revisione commerciale dell’unità di acquisto",
    "commercialHint": "Il team commerciale confermerà come si acquistano questi prodotti: {{products}}. Non devi fare nulla: puoi continuare e verranno inviati segnalati per questa revisione.",
    "pending": "Conferma le quantità in sospeso prima di continuare. Gli altri prodotti non richiedono questa verifica.",
    "review": "Verifica quantità",
    "missing": "Quantità da indicare"
  },
  "admin": {
    "atlasSkills": {
      "title": "Stato Atlas e lettori",
      "refresh": "Verifica",
      "hint": "Dati API, prove di lettura del Portale e inventario delle skill vengono verificati separatamente.",
      "installedVersion": "Installata",
      "activeVersion": "Attiva in Atlas",
      "latestVersion": "Ultima comunicata da Atlas",
      "channel": "Canale disponibile",
      "unknownValue": "Non confermato",
      "checked": "Ultima verifica: {{date}}",
      "observed": "Inventario Atlas: {{date}}",
      "empty": "Atlas ha confermato un inventario vuoto.",
      "noVisibleSkills": "Nessuna skill da mostrare in questa sezione del Portale.",
      "unsupported": "Atlas non pubblica ancora le versioni delle skill tramite API.",
      "not_configured": "Configura e attiva la connessione Atlas per consultare le skill.",
      "unauthorized": "Atlas non ha autorizzato la richiesta. Verifica la connessione API.",
      "unavailable": "Impossibile consultare Atlas. Puoi riprovare.",
      "invalid_response": "Atlas non ha restituito un inventario valido. Le versioni non confermate non vengono mostrate.",
      "states": {
        "current": "Aggiornata",
        "update_available": "Aggiornamento disponibile",
        "development": "In sviluppo",
        "inactive": "Inattiva",
        "unknown": "Non confermato"
      },
      "channels": {
        "stable": "Stabile",
        "development": "Sviluppo",
        "unknown": "Non confermato"
      },
      "runtimeTitle": "API Atlas",
      "apiVersion": "Versione API dichiarata",
      "apiRelease": "Release",
      "recognitionSchema": "Contratto di riconoscimento",
      "documentContract": "Contratto documentale",
      "runtimeMismatch": "L’impronta del codice caricato differisce dalla release dichiarata da Atlas. Non è possibile confermarne l’esecuzione.",
      "runtimeUnavailable": "Atlas non ha confermato la versione API durante questa verifica.",
      "readerTitle": "Ultimo lettore documentale osservato",
      "readerLean": "Lean: è presente una prova esplicita nell’ultima lettura documentale salvata.",
      "readerNotObserved": "Nessuna prova verificabile identifica il lettore documentale.",
      "readerVersion": "Versione del lettore",
      "readerVersionUnknown": "Versione non confermata durante questa verifica",
      "readerObservedAt": "Risultato di lettura osservato: {{date}} (ora spagnola)",
      "readerObservationHint": "Questa prova appartiene a un risultato salvato del Portale. Non conferma la configurazione attuale del servizio e non sostituisce una versione pubblicata da Atlas.",
      "skillsTitle": "Inventario delle skill",
      "skillsHint": "Versioni comunicate da Atlas. Una skill fotografica da sola non identifica il lettore PDF o Excel.",
      "versionConflictLabel": "Verificare inventario",
      "versionConflictHint": "Atlas comunica come ultima una versione precedente a quella installata o attiva. I valori vengono conservati, ma non si conferma che la skill sia aggiornata."
    },
    "approve": "Approva",
    "approveConfirmText": "Verranno creati l’azienda e l’utente, che potrà accedere subito.",
    "approveConfirmTitle": "Approvare questa registrazione?",
    "approved": "Registrazione approvata",
    "assistantOff": "Disattivato",
    "assistantOn": "Attivo",
    "assistantReachable": "Servizio raggiungibile",
    "assistantSection": "Assistente Atlas",
    "assistantToggle": "Mostra l’assistente ai clienti",
    "assistantToggleHint": "Disattivandolo sparisce dal menu e il portale smette di accettare domande. Il servizio resta attivo, quindi puoi riattivarlo quando vuoi.",
    "assistantUnreachable": "Servizio non raggiungibile",
    "assistantAnalyticsTitle": "Cosa chiedono i clienti ad Atlas",
    "assistantAnalyticsSubtitle": "Storico cumulativo delle richieste per individuare esigenze e prodotti che richiedono maggiore assistenza.",
    "assistantAnalyticsAnonymous": "Dati aggregati",
    "assistantAnalyticsQuestions": "Domande effettuate",
    "assistantAnalyticsChats": "Chat avviate",
    "assistantAnalyticsCoverage": "Richieste collegate a prodotti",
    "assistantAnalyticsTopProducts": "Prodotti che generano più dubbi",
    "assistantAnalyticsTopProductsHint": "Prodotti identificati e convalidati da Atlas nelle sue risposte.",
    "assistantAnalyticsQuestionTypes": "Cosa chiedono gli utenti",
    "assistantAnalyticsQuestionTypesHint": "Motivo principale di ogni richiesta, raggruppato per intento.",
    "assistantAnalyticsTopics": "Argomenti più richiesti",
    "assistantAnalyticsTopicsHint": "Aree tecniche che compaiono più frequentemente.",
    "assistantAnalyticsTimeline": "Attività giornaliera",
    "assistantAnalyticsTimelineHint": "Andamento di richieste e conversazioni nel periodo conservato.",
    "assistantAnalyticsTimelineValue": "{{questions}} richieste · {{sessions}} chat",
    "assistantAnalyticsEmpty": "Non ci sono ancora abbastanza richieste per mostrare questa classifica.",
    "assistantAnalyticsPrivacyTitle": "Privacy fin dalla progettazione",
    "assistantAnalyticsPrivacyText": "Questa vista non riceve nomi, indirizzi email o testi completi delle conversazioni. Mostra solo conteggi aggregati.",
    "auditAction": "Azione",
    "auditEmpty": "Nessuna attività registrata",
    "auditEmptyText": "Qui viene raccolto tutto ciò che accade nel portale.",
    "auditEntity": "Elemento",
    "auditWho": "Chi",
    "budgetActions": "Azioni del preventivo",
    "budgetCompany": "Azienda",
    "budgetValidUntil": "Valido fino al",
    "budgetsEmpty": "Nessun preventivo corrisponde alla ricerca.",
    "budgetsHint": "Tutti i preventivi creati dal Portale, con autore e data di creazione.",
    "budgetsSearch": "Cerca per riferimento o progetto",
    "budgetsTitle": "Preventivi del Portale",
    "colApplicant": "Richiedente",
    "colCompany": "Azienda",
    "colOrigin": "Origine",
    "colWaiting": "Richiesta il",
    "extend": "Prorogare la validità",
    "extendDone": "Validità prorogata.",
    "extendField": "Nuova data di validità",
    "extendText": "Scegli fino a quando «{{ref}}» resta valido. Il cliente verrà avvisato.",
    "extendTitle": "Prorogare la validità",
    "hermesApiKey": "Chiave API",
    "hermesApiKeyHint": "Inviata ad Atlas per identificare il portale.",
    "hermesAutoSubmit": "Affidare il lavoro all’invio della richiesta",
    "hermesAutoSubmitHint": "Se spento, Adaltra affida il lavoro a mano.",
    "hermesAutoSubmitNeedsSecret": "Serve il segreto di firma: senza, la risposta di Atlas non può essere verificata.",
    "hermesBaseUrl": "Indirizzo dell’API",
    "hermesCallbackSecret": "Segreto di firma",
    "hermesCallbackSecretHint": "Atlas firma con questo le sue risposte. Non è la chiave API.",
    "hermesCallbackUrl": "Atlas deve rispondere a",
    "hermesClear": "Cancella",
    "hermesEnabled": "Integrazione attiva",
    "hermesEnabledHint": "Se spenta, il portale non invia nulla né accetta risposte.",
    "hermesHint": "Atlas redige i preventivi a partire dalle richieste inviate e li crea in Ada-quote, dove un commerciale li controlla.",
    "hermesSaved": "Connessione salvata.",
    "hermesSecretPlaceholder": "Scrivi per sostituirlo",
    "hermesSecretSet": "Salvato",
    "hermesSecretUnset": "Non configurato",
    "hermesTest": "Prova la connessione",
    "hermesTestFail": {
      "missingBaseUrl": "Manca l’indirizzo dell’API.",
      "missingApiKey": "Manca la chiave API.",
      "unauthorized": "Atlas rifiuta la chiave.",
      "badStatus": "Atlas risponde, ma con un errore ({{status}}).",
      "timeout": "Atlas non ha risposto in tempo.",
      "unreachable": "Impossibile connettersi a quell’indirizzo."
    },
    "hermesTestOk": "Atlas risponde correttamente.",
    "hermesTesting": "Prova in corso…",
    "hermesTimeout": "Attesa massima (ms)",
    "hermesTitle": "Agente Atlas",
    "onlyStaff": "Quest’area è riservata al personale di Adaltra.",
    "registrationsEmpty": "Nessuna registrazione in attesa",
    "registrationsEmptyText": "Qui compariranno le richieste di accesso dei nuovi clienti.",
    "reject": "Rifiuta",
    "rejectConfirmText": "La richiesta sarà contrassegnata come rifiutata e non verrà creato alcun account.",
    "rejectConfirmTitle": "Rifiutare questa registrazione?",
    "rejected": "Registrazione rifiutata",
    "remind": "Reinviare l’avviso",
    "remindDone": "Avviso reinviato al cliente.",
    "sectionNav": "Sezioni di amministrazione",
    "settingsSaved": "Impostazioni salvate",
    "notificationsSaved": "Configurazione delle notifiche salvata.",
    "notificationChannelsTitle": "Canali per gli avvisi generali",
    "notificationChannelsHint": "Scegli come i clienti ricevono gli avvisi generati dal portale.",
    "pushBroadcastTitle": "Invia una notifica push",
    "pushBroadcastHint": "Scrivi un breve avviso per tutte le persone che hanno attivato le notifiche su un dispositivo.",
    "pushBroadcastModalHint": "Verrà inviata a {{count}} dispositivi iscritti. Controlla il contenuto prima di confermare.",
    "composePush": "Scrivi notifica",
    "registeredUsers": "Utenti registrati",
    "pushSubscribedUsers": "Push attivo",
    "pushConfigureBeforeSend": "Configura e attiva prima le chiavi push per inviare un avviso.",
    "pushMessageTitle": "Titolo della notifica",
    "pushMessageBody": "Messaggio",
    "sendPushNow": "Invia notifica",
    "pushBroadcastSent": "Notifica inviata a {{count}} dispositivi.",
    "emailChannelTitle": "Avvisi generali via e-mail",
    "emailChannelHint": "Controlla separatamente se gli avvisi automatici del portale vengono inviati anche via e-mail.",
    "channelPortal": "Portale e campanella",
    "channelPortalHint": "Salva l’avviso nel centro notifiche.",
    "channelEmail": "E-mail",
    "channelEmailHint": "Invia una copia tramite il server SMTP.",
    "channelPush": "Notifica push",
    "channelPushHint": "Mostra l’avviso sul dispositivo anche quando Atlas è chiuso.",
    "smtpTitle": "Server di posta SMTP",
    "smtpHint": "Configura il server per avvisi ed e-mail transazionali del portale.",
    "smtpUrl": "URL SMTP (opzionale)",
    "smtpUrlHint": "Se indicato, sostituisce server e porta separati.",
    "smtpUrlConfigured": "È configurato un URL SMTP protetto. Verrà mantenuto finché non indichi un server diverso.",
    "smtpHost": "Server",
    "smtpPort": "Porta",
    "smtpSecure": "Usa connessione sicura diretta (TLS)",
    "smtpUser": "Utente",
    "smtpPassword": "Password",
    "smtpPasswordHint": "Lascia vuoto per mantenere la password salvata.",
    "smtpFrom": "Mittente",
    "smtpReplyTo": "Rispondi a (opzionale)",
    "smtpEnabled": "Attiva invio e-mail",
    "smtpTestSent": "E-mail di prova inviata a {{email}}.",
    "pushTitle": "Notifiche push",
    "pushHint": "Configura le chiavi VAPID stabili usate da Atlas con i browser.",
    "pushPublicKey": "Chiave pubblica VAPID",
    "pushPrivateKey": "Chiave privata VAPID",
    "pushPrivateKeyHint": "Non viene più mostrata. Lascia vuoto per mantenerla.",
    "pushSubject": "Contatto del servizio",
    "pushSubjectHint": "Di solito un indirizzo come mailto:support@example.com.",
    "pushEnabled": "Attiva notifiche push",
    "generateVapid": "Genera chiavi",
    "sendTest": "Invia prova",
    "pushTestSent": "Notifica di prova inviata a questo dispositivo.",
    "pushTestNoSubscription": "La configurazione funziona, ma questo utente non ha ancora dispositivi iscritti.",
    "configurationFromEnvironment": "Questa configurazione proviene dall’ambiente del server. Salvandola qui verrà gestita da Amministrazione.",
    "statActiveUsers": "Utenti attivi",
    "statOpenTickets": "Ticket aperti",
    "statPendingRegistrations": "Registrazioni in attesa",
    "subtitle": "Registrazioni clienti, preventivi, supporto e impostazioni del portale.",
    "tabAudit": "Audit",
    "tabAssistantAnalytics": "Analisi Atlas",
    "tabBudgets": "Preventivi",
    "tabRegistrations": "Registrazioni",
    "tabSettings": "Impostazioni",
    "tabNotifications": "Notifiche",
    "tabEmail": "E-mail",
    "tabTickets": "Assistenza",
    "tabUsers": "Utenti",
    "tabReleases": "Novità",
    "releasesTitle": "Novità della piattaforma",
    "releasesDescription": "Modifiche pubblicate per Commerciali e Gestori.",
    "releaseNew": "Nuova release",
    "releasesEmpty": "Non ci sono ancora release",
    "releasesEmptyText": "Le novità pubblicate appariranno qui.",
    "releaseStatus": {
      "draft": "Bozza",
      "published": "Pubblicata"
    },
    "releaseLinkedCount": "{{count}} richieste collegate",
    "releaseIncludesYours": "Include una tua richiesta",
    "releaseEdit": "Modifica release",
    "releaseVersion": "Versione",
    "releaseTitle": "Titolo",
    "releaseSummary": "Riepilogo",
    "releaseChanges": "Modifiche",
    "releaseChangesHelp": "Inserisci una modifica per riga.",
    "releaseLinkedRequests": "Richieste collegate",
    "releaseLinkedRequestsHelp": "La pubblicazione completerà tutte le richieste collegate.",
    "releaseSaved": "Release salvata.",
    "platformRequestTitle": "Proponi un miglioramento",
    "platformRequestAction": "Proponi un miglioramento o una modifica",
    "platformRequestDescription": "Indicaci cosa dovrebbe essere aggiunto o migliorato nella piattaforma.",
    "platformRequestSubject": "Titolo della richiesta",
    "platformRequestDetails": "Descrizione",
    "platformRequestSend": "Invia richiesta",
    "platformRequestSent": "Richiesta inviata.",
    "platformRequestsAll": "Richieste dei dipendenti",
    "platformRequestsMine": "Le mie richieste",
    "platformRequestsAllText": "Esamina, pianifica e collega le proposte a una release.",
    "platformRequestsMineText": "Controlla lo stato e la versione che include ogni proposta.",
    "platformRequestsEmpty": "Nessuna richiesta",
    "platformRequestsEmptyText": "Le nuove proposte appariranno qui.",
    "platformRequestStatus": {
      "new": "Nuova",
      "under_review": "In revisione",
      "planned": "Pianificata",
      "declined": "Rifiutata",
      "completed": "Completata"
    },
    "platformRequestAdminNote": "Nota dell’amministratore",
    "platformRequestIncluded": "Inclusa nella v{{version}}",
    "platformRequestReview": "Esamina richiesta",
    "platformRequestSaved": "Richiesta aggiornata.",
    "usersTitle": "Gestione utenti",
    "usersHint": "Gestisci l’accesso al portale e il collegamento commerciale di ogni account.",
    "usersCount": "{{count}} utenti",
    "searchUsers": "Cerca utenti",
    "user": "Utente",
    "userRole": "Ruolo",
    "userRole_client": "Cliente",
    "userRole_commercial": "Commerciale",
    "userRole_manager": "Gestore",
    "userRole_admin": "Amministratore",
    "rolesAdminOnly": "Solo un amministratore può modificare i ruoli.",
    "emailBroadcastTitle": "Invia un’e-mail generale",
    "emailBroadcastHint": "Invia lo stesso messaggio in copia nascosta a tutti gli utenti attivi del ruolo scelto.",
    "emailAudienceRole": "Destinatari",
    "emailSubject": "Oggetto",
    "emailBody": "Messaggio",
    "addAttachments": "Aggiungi allegati",
    "noAttachments": "Nessun allegato · massimo 5 file da 10 MB",
    "sendEmailNow": "Invia e-mail",
    "sendingEmail": "Invio…",
    "emailBroadcastSent": "E-mail inviata a {{count}} destinatari con {{attachments}} allegati.",
    "userStatus_pending": "In attesa",
    "userStatus_active": "Attivo",
    "userStatus_blocked": "Bloccato",
    "customerCode": "Codice cliente",
    "generatedBudgets": "Richieste e preventivi",
    "viewUserRequests": "Visualizza tutte le richieste di questo utente",
    "userRequestsTitle": "Richieste di {{name}}",
    "userRequestsHint": "Include bozze, letture, revisioni e preventivi generati. Puoi continuare, rianalizzare e gestire le richieste dell’utente.",
    "userRequestsEmpty": "Questo utente non ha ancora creato richieste.",
    "userRequestItems": "{{count}} articoli",
    "userRequestCreated": "Creata",
    "userRequestFiles": "File",
    "userRequestBudget": "Preventivo",
    "userRequestBudgetPending": "Non ancora generato",
    "userRequestMaterials": "Elenco materiali",
    "userRequestMaterialsPending": "L’elenco dei materiali non è ancora disponibile in questa fase.",
    "assistantAnalyticsRecentQuestions": "Domande recenti",
    "assistantAnalyticsRecentQuestionsHint": "Domande inviate all’assistente con l’account che le ha poste.",
    "assistantAnalyticsUnknownUser": "Utente non disponibile",
    "lastAccess": "Ultimo accesso",
    "neverAccessed": "Mai",
    "editUser": "Modifica utente",
    "adaQuoteCustomerCodeAdminHint": "Codice AdaQuote dell’azienda o filiale. Si applica ai suoi account Cliente; altre filiali possono condividerlo senza essere modificate.",
    "editCustomerCode": "Modifica codice cliente",
    "editCustomerCodeFor": "Modifica codice cliente di {{name}}",
    "staffCustomerCodeHint": "L’amministratore può assegnare a questo account un codice personale. Senza un codice, utilizza 0.",
    "staffPersonalCustomerCodeHint": "Codice personale di questo utente per inviare e consultare i preventivi. L’azienda e gli altri utenti non vengono modificati. Lascia vuoto per usare 0.",
    "personalCustomerCodeHint": "Codice personale di questo amministratore per inviare e consultare i preventivi. Gli altri utenti non vengono modificati. Lascia vuoto per usare 0.",
    "userSaved": "Utente aggiornato.",
    "ticketClosed": "Chiuso",
    "ticketInProgress": "In corso",
    "ticketOpen": "Aperto",
    "ticketsEmpty": "Nessun ticket",
    "ticketsEmptyText": "Le richieste di assistenza dei clienti compariranno qui.",
    "title": "Amministrazione",
    "withdraw": "Ritirare l’offerta",
    "withdrawDone": "Preventivo ritirato.",
    "withdrawText": "«{{ref}}» passerà a scaduto e il cliente non potrà più accettarlo. Verrà avvisato.",
    "withdrawTitle": "Ritirare questo preventivo?",
    "adaQuoteTitle": "Ada-quote",
    "adaQuoteHint": "Connessione diretta facoltativa per sincronizzare i preventivi. Stock e PDF dispongono anche della propria consultazione tramite Atlas.",
    "adaQuoteBaseUrl": "Indirizzo dell’API",
    "adaQuoteApiKey": "Chiave API",
    "adaQuoteApiKeyHint": "Inviata ad Ada-quote per identificare il portale.",
    "adaQuoteEnabled": "Connessione attiva",
    "adaQuoteEnabledHint": "Se disattivata, la sincronizzazione diretta con Ada-quote viene saltata. La connessione Atlas resta invariata.",
    "adaQuoteSaved": "Connessione salvata.",
    "adaQuoteTestOk": "Ada-quote risponde correttamente.",
    "adaQuoteTestNoHealth": "Ada-quote risponde e accetta la chiave, anche se non ha una pagina di stato.",
    "adaQuoteTestFail": {
      "missingBaseUrl": "Manca l’indirizzo dell’API.",
      "missingApiKey": "Manca la chiave API.",
      "unauthorized": "Ada-quote rifiuta la chiave.",
      "badStatus": "Ada-quote risponde, ma con un errore ({{status}}).",
      "timeout": "Ada-quote non ha risposto in tempo.",
      "unreachable": "Impossibile connettersi all’indirizzo di Ada-quote."
    },
    "adaQuoteScope": "Ogni cliente vede solo i propri preventivi: il portale usa il codice cliente AdaQuote dell’azienda della sessione, mai un codice inviato dal browser.",
    "connectionChecking": "Verifica in corso…",
    "connectionKeyNotVerified": "Risponde, ma non abbiamo potuto verificare la chiave.",
    "modules": {
      "title": "Moduli",
      "checking": "Verifica di ogni modulo…",
      "summary": "{{active}} su {{total}} attivi",
      "withIssues": "{{count}} con problemi",
      "refresh": "Verifica ora",
      "version": "Versione {{version}}",
      "versionUnknown": "Versione non disponibile",
      "configure": "Configura",
      "tools": "Strumenti",
      "serverSwitch": "Si attiva sul server",
      "state": {
        "on": "Attivo",
        "off": "Disattivato",
        "error": "Errore",
        "warning": "Non aggiornato",
        "checking": "Verifica…"
      },
      "atlas": {
        "title": "Atlas · API di lettura",
        "text": "Legge i documenti delle richieste, identifica i prodotti e prepara i preventivi."
      },
      "adaQuote": {
        "title": "Ada-quote",
        "text": "Prezzi, sconti, stock e preventivi nell’ERP."
      },
      "customers": {
        "title": "Anagrafica clienti",
        "text": "Clienti e indirizzi di consegna di Ada, per assegnare il cliente e passare all’ordine.",
        "detail": "{{count}} clienti · versione {{version}} · verificato {{date}}",
        "stale": "Non aggiornata dal {{date}}",
        "unavailable": "Atlas non risponde"
      },
      "catalog": {
        "title": "Catalogo prodotti",
        "text": "Copia del Master prodotti pubblicato da Atlas, per cercare e convalidare i riferimenti.",
        "detail": "{{count}} prodotti · versione {{version}} · {{date}}"
      },
      "assistant": {
        "text": "Chat di aiuto di Atlas per il personale e i clienti."
      }
    },
    "notifConfig": {
      "pushTitle": "Configurazione degli avvisi",
      "pushHint": "Web Push e i canali attraverso cui arrivano gli avvisi del portale.",
      "emailTitle": "Configurazione e-mail",
      "emailHint": "Server di posta (SMTP) e avvisi via e-mail.",
      "sender": "Mittente",
      "notConfigured": "Non configurato"
    },
    "connection": {
      "connected": "Connesso",
      "error": "Errore",
      "disconnected": "Disconnesso"
    },
    "direccion": {
      "interna": "Questo indirizzo esiste solo dentro la rete locale. Il portale lo raggiunge da qui, ma smetterà di farlo una volta distribuito altrove. Servirà un tunnel o un indirizzo pubblico.",
      "sinCifrar": "Indirizzo non cifrato (http). La chiave API viaggia in un’intestazione: fuori dalla propria rete conviene usare https.",
      "malformada": "Questo indirizzo non sembra valido. Deve iniziare con https:// o http://."
    },
    "catalogSync": "Copia catalogo",
    "catalogSyncing": "Copia in corso…",
    "catalogSynced": "Catalogo copiato: {{count}} articoli ({{deactivated}} ritirati).",
    "catalogAlreadyCurrent": "La copia è già aggiornata: {{count}} articoli.",
    "approvedEmailUnavailable": "Account approvato. Non è stato possibile inviare l’email di notifica al cliente.",
    "requestSendToAtlas": "Invia ad Atlas",
    "requestSendConfirm": "Invierai {{ref}}, con {{count}} righe, ad Atlas per creare il preventivo AdaQuote di {{name}}. Verranno utilizzati i dati e il codice cliente del proprietario.",
    "requestReviewWithAtlas": "Verifica con Atlas",
    "requestDiscardSuggestion": "Non aggiungere",
    "requestRecovered": "Elenco recuperato da {{ref}}. Completa la verifica prima dell’invio.",
    "requestAlreadySent": "Questo incarico è già stato inviato ad Atlas o ha un preventivo associato.",
    "requestNeedsReview": "L’elenco deve completare la verifica prima dell’invio.",
    "requestContinue": "Continua richiesta",
    "requestOpen": "Apri richiesta",
    "requestReanalyze": "Analizza di nuovo",
    "requestDelete": "Elimina richiesta",
    "requestCancel": "Annulla richiesta",
    "requestRestore": "Ripristina richiesta",
    "requestBackToUsers": "Torna agli utenti",
    "requestActingFor": "Gestione della richiesta di {{name}} · {{company}}",
    "requestExistingOnly": "Continua questa richiesta o torna ad Amministrazione per sceglierne un’altra.",
    "requestActionTitle_reanalyze": "Analizza nuovamente i documenti",
    "requestActionTitle_delete": "Elimina richiesta",
    "requestActionTitle_cancel": "Annulla richiesta",
    "requestActionConfirm_reanalyze": "Analizzare nuovamente i documenti di {{ref}}, di {{name}}? L’elenco verrà riesaminato e i risultati dovranno essere confermati prima dell’invio.",
    "requestActionConfirm_delete": "Eliminare definitivamente {{ref}}, di {{name}}, e i suoi file? Questa azione non può essere annullata.",
    "requestActionConfirm_cancel": "Annullare {{ref}}, di {{name}}? Potrai poi ripristinarla o eliminarla definitivamente da Amministrazione.",
    "requestBudgetReadOnly": "Consultazione amministrativa del preventivo. L’accettazione e il rifiuto spettano al cliente.",
    "userRole_orders": "Ordini",
    "deleteUserDescription": "L’accesso sarà revocato e l’utente non sarà più visibile in questo elenco. Richieste, preventivi e cronologia delle operazioni saranno conservati.",
    "passwordChangePending": "Cambio password richiesto",
    "forcePasswordResetDescription": "Un’email conterrà un link valido un’ora per inserire e ripetere una nuova password. Dopo l’invio, le sessioni saranno chiuse e il cambio sarà necessario per accedere nuovamente.",
    "ownPasswordAction": "Cambia la password dal tuo profilo",
    "deletingUser": "Eliminazione…",
    "sendingPasswordReset": "Invio…",
    "userDeleted": "Utente eliminato. Richieste e preventivi sono conservati.",
    "deleteUser": "Elimina utente",
    "sendPasswordReset": "Invia email",
    "cannotDeleteSelf": "Non puoi eliminare il tuo account",
    "forcePasswordResetFor": "Richiedi a {{name}} di cambiare la password",
    "passwordResetSent": "Email inviata. L’utente deve cambiare la password per accedere nuovamente.",
    "forcePasswordReset": "Richiedi cambio password",
    "deleteUserFor": "Elimina {{name}}",
    "budgetCreatedBy": "Creato da",
    "budgetCreatedAt": "Data di creazione",
    "budgetsPerPage": "Preventivi per pagina",
    "budgetPageRange": "{{from}}–{{to}} di {{count}}"
  },
  "assistant": {
    "title": "Assistente Atlas",
    "placeholder": "Scrivi la tua domanda…",
    "send": "Invia",
    "thinking": "Atlas sta scrivendo…",
    "newConversation": "Nuova conversazione",
    "resetConfirmTitle": "Iniziare una nuova conversazione?",
    "resetConfirmText": "Si aprirà una chat vuota. Ogni conversazione e la sua intera cronologia vengono eliminate 24 ore dopo la creazione, anche se continui a scrivere.",
    "emptyTitle": "Come posso aiutarti?",
    "emptyText": "Chiedimi dei prodotti Ekselans: caratteristiche, schede tecniche, manuali e disponibilità.",
    "suggestion1": "Quali access point WiFi 6 avete?",
    "suggestion2": "Mostrami la scheda tecnica dell’AX 3000",
    "suggestion3": "Come richiedo un’estensione di garanzia?",
    "you": "Tu",
    "assistantName": "Atlas",
    "disclaimer": "Atlas può sbagliare. Controlla sempre i riferimenti prima di confermare un ordine.",
    "unavailableTitle": "L’assistente non è disponibile",
    "unavailableText": "Non siamo riusciti a contattare Atlas. Riprova tra qualche minuto.",
    "drawingDiagram": "Disegno dello schema…",
    "downloadDiagram": "Scarica lo schema in PNG",
    "diagramFileName": "schema-atlas",
    "enlargeImage": "Ingrandisci l’immagine",
    "enlargeDiagram": "Ingrandisci lo schema",
    "stop": "Interrompi la risposta",
    "stopped": "Risposta interrotta",
    "copyAnswer": "Copia la risposta",
    "jumpToLatest": "Vai all’ultimo messaggio",
    "threadLabel": "Conversazione con Atlas",
    "charsLeft_one": "Resta {{count}} carattere",
    "charsLeft_other": "Restano {{count}} caratteri",
    "charLimit": "È stato raggiunto il limite di {{max}} caratteri.",
    "resetConfirmAction": "Ricomincia",
    "sendFailed": "Non è stato possibile inviare il messaggio.",
    "composerHint": "Invio per inviare · Maiusc+Invio per andare a capo",
    "conversations": "Conversazioni",
    "showConversations": "Mostra le conversazioni",
    "hideConversations": "Nascondi le conversazioni",
    "untitled": "Nuova conversazione",
    "newChat": "Nuova conversazione",
    "noConversations": "Non hai ancora parlato con Atlas",
    "renameTitle": "Rinomina la conversazione",
    "renameLabel": "Nome",
    "removeTitle": "Eliminare questa conversazione?",
    "removeText": "La conversazione e la relativa trascrizione verranno eliminate definitivamente. L’azione non può essere annullata.",
    "remove": "Elimina",
    "conversationOptions": "Opzioni della conversazione",
    "olderThanWeek": "Precedenti",
    "thisWeek": "Questa settimana",
    "reasoning": "Atlas sta ragionando…",
    "reasoningSteps": {
      "searching": "Ricerca delle informazioni",
      "consulting": "Consultazione della documentazione",
      "comparing": "Confronto delle opzioni",
      "verifying": "Verifica dei dati",
      "identifying": "Identificazione del prodotto",
      "clarifying": "Chiarimento dei requisiti",
      "preparing": "Preparazione della risposta",
      "reviewing": "Analisi della richiesta",
      "working": "Elaborazione della richiesta"
    }
  },
  "assistantWidget": {
    "needHelp": "Hai bisogno di aiuto?",
    "productQuestion": "Hai dubbi su un prodotto?",
    "open": "Parla con la mascotte Atlas",
    "title": "Atlas",
    "status": "Il tuo assistente prodotti",
    "greeting": "Ciao! Sono Atlas. Chiedimi informazioni su un prodotto, un equivalente o il tuo prossimo preventivo.",
    "expand": "Apri l’Assistente completo",
    "placeholder": "Scrivi ad Atlas…",
    "send": "Invia messaggio",
    "thinking": "Atlas sta pensando…"
  },
  "auth": {
    "signInTitle": "Accedi al tuo portale",
    "signInSubtitle": "Consulta richieste e preventivi in un unico posto.",
    "email": "Indirizzo e-mail",
    "password": "Password",
    "showPassword": "Mostra la password",
    "hidePassword": "Nascondi la password",
    "rememberMe": "Ricordami",
    "forgotPassword": "Hai dimenticato la password?",
    "signIn": "Accedi",
    "signingIn": "Accesso in corso…",
    "secureAccess": "Accesso sicuro per i clienti Adaltra",
    "noAccount": "Non hai ancora un account?",
    "createAccount": "Crea un account",
    "haveAccount": "Hai già un account?",
    "backToSignIn": "Torna all'accesso",
    "orContinueWith": "oppure continua con",
    "continueWithGoogle": "Continua con Google",
    "continueWithMicrosoft": "Continua con Outlook",
    "googleShort": "Google",
    "microsoftShort": "Outlook",
    "providerNotConfigured": "Questo metodo di accesso non è ancora configurato. Aggiungi le credenziali sul server per attivarlo.",
    "heroTitle": "Dalla tua distinta materiali al preventivo, senza complicazioni.",
    "heroSubtitle": "Fotografa, controlla e conferma. Il controllo resta sempre tuo.",
    "heroTitleRegister": "Richiedi preventivi in modo più semplice.",
    "heroSubtitleRegister": "Crea il tuo accesso al portale clienti e centralizza tutte le richieste della tua azienda.",
    "trustDocuments": "I tuoi documenti, protetti",
    "trustReview": "Controllo umano prima dell'invio",
    "trustSecureSignUp": "Registrazione sicura e protetta",
    "trustTracking": "Monitoraggio fin dal primo giorno",
    "registerTitle": "Crea il tuo accesso",
    "registerSubtitle": "Inserisci i dati principali della tua azienda per iniziare a usare il portale.",
    "fullName": "Nome e cognome",
    "phone": "Telefono",
    "companyName": "Azienda",
    "taxId": "Partita IVA",
    "createAccountAction": "Crea l'account",
    "registeredTitle": "Abbiamo i tuoi dati",
    "registrationReceived": "Il team di Adaltra verificherà i dati aziendali e invierà le credenziali all'indirizzo indicato.",
    "forgotTitle": "Recupera la password",
    "forgotSubtitle": "Inserisci la tua e-mail e ti invieremo un link per crearne una nuova.",
    "sendLink": "Invia il link",
    "resetEmailSent": "Se l'indirizzo corrisponde a un account registrato, riceverai un link per reimpostare la password.",
    "resetTitle": "Crea una nuova password",
    "newPassword": "Nuova password",
    "repeatPassword": "Ripeti la password",
    "passwordUpdated": "Password aggiornata. Ora puoi accedere.",
    "passwordHint": "Almeno 10 caratteri, con lettere e numeri.",
    "currentPassword": "Password attuale",
    "changePassword": "Cambia password",
    "setPassword": "Imposta una password",
    "heroAccent": "senza complicazioni.",
    "heroAccentRegister": "più semplice.",
    "trustDevice": "Dispositivo attendibile",
    "trustDeviceHint": "Non richiedere il codice in questo browser per 30 giorni."
  },
  "authProvider": {
    "google": "Registrazione con Google",
    "microsoft": "Registrazione con Outlook",
    "password": "Registrazione via modulo"
  },
  "brand": {
    "name": "Atlas",
    "portal": "Portale clienti",
    "poweredBy": "Con la tecnologia di",
    "version": "Versione {{version}}",
    "company": "Adaltra"
  },
  "budget": {
    "period": "Data di emissione",
    "dateFrom": "Dal",
    "dateTo": "Al",
    "invalidDates": "La data finale deve essere uguale o successiva a quella iniziale.",
    "paginationSummary": "{{from}}–{{to}} di {{total}} preventivi",
    "periods": {
      "all": "Tutte le date",
      "today": "Oggi",
      "week": "Ultimi 7 giorni",
      "month": "Ultimi 30 giorni",
      "quarter": "Ultimi 90 giorni",
      "year": "Quest’anno",
      "custom": "Intervallo personalizzato"
    },
    "listTitle": "Preventivi",
    "listSubtitle": "Consulta e scarica i tuoi ordini approvati.",
    "refresh": "Aggiorna",
    "refreshing": "Aggiornamento…",
    "searchPlaceholder": "Cerca per riferimento o progetto",
    "emptyTitle": "Ancora nessun preventivo",
    "emptyText": "I preventivi appariranno qui dopo l’accettazione dell’ordine.",
    "validUntil": "Valido fino al",
    "issuedOn": "Emesso il",
    "detailTitle": "Dettaglio del preventivo",
    "linkedRequest": "Richiesta collegata",
    "downloadPdf": "Scarica il PDF",
    "approve": "Approva il preventivo",
    "reject": "Rifiuta",
    "approveDialogTitle": "Approvare il preventivo?",
    "approveDialogText": "Con l'approvazione Adaltra avvierà la preparazione dell'ordine.",
    "rejectDialogTitle": "Rifiutare il preventivo?",
    "rejectDialogText": "Indicaci il motivo così potremo proporti qualcosa di migliore.",
    "rejectReason": "Motivo del rifiuto",
    "approvedMessage": "Preventivo approvato",
    "rejectedMessage": "Preventivo rifiutato",
    "pendingEyebrow": "IN ATTESA DI APPROVAZIONE",
    "pendingTitle": "Controlla e approva il preventivo",
    "pendingText": "Verifica l'importo e le condizioni prima di confermare la proposta.",
    "draftEyebrow": "Non è ancora definitivo",
    "draftTitle": "Il tuo preventivo è in revisione",
    "draftText": "È pronto e un commerciale di Adaltra lo sta controllando. Puoi consultarlo intanto, ma gli importi possono ancora cambiare: potrai accettarlo o rifiutarlo quando te lo invierà.",
    "approvedEyebrow": "PREVENTIVO APPROVATO",
    "approvedTitle": "Preventivo approvato",
    "approvedText": "La proposta è stata approvata e puoi scaricare il documento definitivo.",
    "orderedEyebrow": "TRASFORMATO IN ORDINE",
    "orderedTitle": "Ordine {{order}} creato",
    "orderedText": "Il preventivo è stato vinto e l’ordine è già elaborato in MTR.",
    "sentEyebrow": "PREVENTIVO INVIATO",
    "sentTitle": "Il tuo preventivo è pronto",
    "sentText": "Controlla il riepilogo e scarica il documento completo in PDF.",
    "expiredEyebrow": "PREVENTIVO SCADUTO",
    "expiredTitle": "Questo preventivo è scaduto",
    "expiredText": "Richiedi un aggiornamento per rivedere prezzi e disponibilità.",
    "rejectedEyebrow": "PREVENTIVO RIFIUTATO",
    "rejectedTitle": "Hai rifiutato questo preventivo",
    "rejectedText": "Puoi richiedere una nuova proposta quando vuoi.",
    "commercialRejectedEyebrow": "PREVENTIVO NON APPROVATO",
    "commercialRejectedTitle": "Non ha superato la revisione commerciale",
    "commercialRejectedText": "Puoi richiedere una nuova proposta.",
    "unitPrice": "Prezzo unitario",
    "pricePending": "Prezzo su richiesta",
    "partialTotal_one": "Il totale è parziale: manca il prezzo di 1 prodotto.",
    "partialTotal_other": "Il totale è parziale: mancano i prezzi di {{count}} prodotti.",
    "discount": "Sconto",
    "lineTotal": "Importo",
    "requestChanges": "Richiedi modifiche",
    "requestChangesDialogTitle": "Che cosa va corretto?",
    "requestChangesDialogText": "Il preventivo torna ad Adaltra con la tua nota e resta valido: non lo stai rifiutando. Riceverai una proposta corretta.",
    "requestChangesLabel": "Che cosa rivedere",
    "requestChangesHint": "Indica la riga, la quantità o il codice che non torna. Più sei preciso, prima torna sistemato.",
    "changesSentMessage": "Abbiamo inviato la tua richiesta ad Adaltra",
    "changesEyebrow": "MODIFICHE RICHIESTE",
    "changesTitle": "Adaltra sta esaminando la tua richiesta",
    "changesText": "Riceverai una proposta corretta. Nel frattempo puoi comunque accettarlo o rifiutarlo così com’è.",
    "changesNoteLabel": "Quello che hai chiesto di correggere",
    "viewPdf": "Vedi il PDF",
    "hidePdf": "Nascondi il PDF",
    "openPdfInTab": "Apri in una scheda",
    "pdfNotReady": "Il PDF non è ancora disponibile",
    "pdfNotReadyText": "Adaltra lo allegherà una volta firmato. Il dettaglio delle righe qui sotto è già definitivo.",
    "pdfFallback": "Il tuo browser non può mostrare il PDF qui. Aprilo in una scheda o scaricalo.",
    "revision": "Revisione {{count}}",
    "expiredOn": "Scaduto il {{date}}",
    "expiresToday": "Scade oggi",
    "expiresIn_one": "Scade tra {{count}} giorno",
    "expiresIn_other": "Scade tra {{count}} giorni",
    "requestAgain": "Chiedine uno nuovo",
    "decide": "Decidi"
  },
  "budgetStatus": {
    "draft": "In revisione commerciale",
    "sent": "Inviato",
    "pending_approval": "In attesa di approvazione",
    "approved": "Approvato",
    "rejected": "Rifiutato",
    "expired": "Scaduto",
    "changes_requested": "Modifiche richieste",
    "ordered": "Ordine creato"
  },
  "common": {
    "openInNewTab": "Apri in un’altra scheda",
    "continue": "Continua",
    "back": "Indietro",
    "cancel": "Annulla",
    "save": "Salva",
    "saveChanges": "Salva le modifiche",
    "saved": "Modifiche salvate",
    "delete": "Elimina",
    "edit": "Modifica",
    "add": "Aggiungi",
    "search": "Cerca",
    "filter": "Filtra",
    "all": "Tutti",
    "close": "Chiudi",
    "confirm": "Conferma",
    "download": "Scarica",
    "retry": "Riprova",
    "loadMore": "Carica altri",
    "loading": "Caricamento…",
    "saving": "Salvataggio…",
    "sending": "Invio…",
    "optional": "Facoltativo",
    "required": "Obbligatorio",
    "yes": "Sì",
    "no": "No",
    "of": "di",
    "page": "Pagina",
    "quantity": "Quantità",
    "unit": "Unità",
    "description": "Descrizione",
    "code": "Codice",
    "reference": "Riferimento",
    "brandLabel": "Marca",
    "date": "Data",
    "status": "Stato",
    "total": "Totale",
    "subtotal": "Imponibile",
    "vat": "IVA",
    "project": "Progetto",
    "actions": "Azioni",
    "noResults": "Nessun risultato",
    "seeAll": "Vedi tutto",
    "seeDetail": "Vedi dettaglio",
    "preview": "Anteprima",
    "rotate": "Ruota",
    "zoom": "Ingrandisci",
    "empty": "Ancora nessun dato",
    "copy": "Copia",
    "copied": "Copiato",
    "dismiss": "Ignora",
    "rename": "Rinomina",
    "today": "Oggi",
    "yesterday": "Ieri",
    "showMore": "Mostra di più",
    "showLess": "Mostra di meno",
    "view": "Vedi",
    "catalogName": "catalogo",
    "brand": "Marca"
  },
  "dashboard": {
    "attentionAllDone": "Tutto in ordine",
    "attentionAllDoneText": "Non c’è nulla in attesa da parte tua. Crea una richiesta quando ti serve.",
    "attentionNextStep": "Passaggio successivo",
    "attentionTitle": "Richiede la tua attenzione",
    "createFirst": "Crea la prima richiesta",
    "emptyBudgets": "I tuoi preventivi compariranno qui quando saranno pronti.",
    "emptyRequests": "Non hai ancora creato nessuna richiesta.",
    "greeting": "{{salutation}}, {{name}}",
    "greetings": {
      "morning": "Buongiorno",
      "afternoon": "Buon pomeriggio",
      "night": "Buonasera"
    },
    "groupDecide": "Pronti per la tua decisione",
    "groupDecideText": "Accettali, richiedi modifiche o rifiutali.",
    "groupExpired": "Scaduti",
    "groupExpiredText": "Non si possono più accettare. Chiedine uno nuovo se ti serve ancora.",
    "groupReview": "In attesa del tuo controllo",
    "reviewReadingText": "La lettura del documento attende la tua conferma.",
    "reviewProductsText": "Controlla l’elenco e risolvi i prodotti in sospeso.",
    "reviewRecommendationsText": "Restano raccomandazioni di Atlas da controllare.",
    "reviewConfirmationText": "L’elenco è stato controllato. Conferma e invia la richiesta.",
    "groupReviewText": "Atlas ha letto l’elenco. Controllalo e correggi quello che serve.",
    "readingErrorText": "Non è stato possibile leggere il file. Apri la richiesta per riprovare l’analisi o sostituire i file.",
    "groupSubmitted": "Inviate ad Atlas",
    "groupSubmittedText": "Stiamo preparando il preventivo.",
    "inProgressText": "Ce ne stiamo occupando. Non devi fare nulla.",
    "inProgressViewAll": "Vedi tutte le {{count}} richieste in corso",
    "inProgressTitle": "In corso",
    "itemsAndLines": "{{count}} righe",
    "newRequestCta": "Nuova richiesta di preventivo",
    "newRequestHint": "Fotografa la distinta materiali o caricala come file.",
    "recentBudgets": "Ultimi preventivi",
    "recentEmpty": "Le tue richieste e i tuoi preventivi compariranno qui quando vengono chiusi.",
    "recentRequests": "Ultime richieste",
    "recentTitle": "La tua attività recente",
    "reviewCta": "Controlla la richiesta",
    "seeBudgets": "Vedi tutti i preventivi",
    "seeRequests": "Vedi tutte le richieste",
    "statApprovedBudgets": "Preventivi approvati",
    "statApprovedTotal": "Importo approvato",
    "statDecision": "In attesa della tua decisione",
    "statReview": "In attesa della tua revisione",
    "statTotalBudgets": "Preventivi totali",
    "statOpenRequests": "Richieste in corso",
    "statPendingBudgets": "Preventivi in attesa",
    "subtitle": "Ecco lo stato delle tue richieste e dei tuoi preventivi.",
    "summaryCount": "{{count}} preventivi",
    "summaryTitle": "Approvato finora",
    "toDecide": "Pronto per la tua decisione",
    "toReview": "In attesa del tuo controllo",
    "validatedQuoteText": "Il preventivo è convalidato e disponibile per la consultazione o il download prima dell’accettazione.",
    "viewValidatedQuote": "Vedi preventivo",
    "attentionEmpty": "Non ci sono richieste o preventivi da controllare.",
    "inProgressEmpty": "Le richieste appariranno qui mentre Atlas prepara i preventivi.",
    "inProgressOpen": "Vedi richieste in corso"
  },
  "valuation": {
    "informational": "Prezzi calcolati da Ada-quote per il cliente e la destinazione selezionati. La data di consegna e il numero d’ordine restano salvati in Atlas; questa consultazione non li applica.",
    "basePrice": "Prezzo base",
    "unitPriceNet": "Prezzo netto",
    "literalDiscounts": "D1, D2 e D3 sono gli sconti letterali ricevuti, nel loro ordine. Tipo e base non sono confermati; non vengono aggiunte percentuali né eseguiti ricalcoli.",
    "queriedAt": "Consultato (ora spagnola)",
    "informationalWaiting": "Prezzi ricevuti. La conferma economica è ancora in attesa.",
    "receivedBlocked": "Atlas ha salvato i dati dell’ordine. La valorizzazione economica è in attesa dell’integrazione Ada-quote.",
    "noDiscounts": "Nessuno sconto",
    "title": "Valorizzazione dell’ordine",
    "subtitle": "Controlla prezzi e sconti applicati a questo cliente prima della conferma.",
    "request": "Ottieni valorizzazione",
    "refresh": "Aggiorna valorizzazione",
    "pending": "Ada-quote sta preparando la valorizzazione…",
    "notRequested": "Richiedi la valorizzazione per ricevere prezzi e condizioni del cliente. Questo passaggio non conferma alcun ordine.",
    "stale": "La valorizzazione precedente non è più attuale. Controlla cliente, indirizzo e quantità prima di richiedere nuovamente i prezzi.",
    "expired": "La valorizzazione è scaduta. Aggiornala per controllare gli importi correnti.",
    "linesTitle": "Prodotti valorizzati",
    "article": "Articolo",
    "quantity": "Quantità",
    "unitPrice": "Prezzo unitario",
    "discounts": "Sconti",
    "netUnitPrice": "Prezzo scontato",
    "lineTotal": "Importo",
    "sourceNotice": "Prezzi, sconti e importi sono mostrati come forniti da Ada-quote.",
    "addedByProvider": "Aggiunta da Ada-quote (non è nell'elenco)",
    "addedWarning": "Avviso",
    "addedWillRemove": "Verrà rimosso dall’ordine.",
    "addedNotesHint": "La decisione viene inviata ad Ada-quote nelle note del preventivo.",
    "addedTitle": "Ada-quote ha aggiunto prodotti all’ordine",
    "addedIntro": "Durante la valorizzazione, Ada-quote ha aggiunto prodotti che non erano nell’elenco. Decidi se mantenerli nell’ordine e, se vuoi, indica il loro prezzo.",
    "addedKeep": "Mantieni",
    "addedRemove": "Rimuovi",
    "addedPrice": "Prezzo unitario (€)",
    "addedPriceHelp": "Vuoto: si mantiene il prezzo di Ada-quote ({{price}}).",
    "addedAdaPrice": "Prezzo Ada-quote: {{price}}",
    "addedSave": "Salva decisione",
    "addedLater": "Più tardi",
    "addedChange": "Modifica",
    "addedRemoved": "Rimossa dall’ordine",
    "addedPriceChanged": "Prezzo indicato da Ordini",
    "addedPending": "Decidi se mantenere i prodotti aggiunti da Ada-quote prima di continuare.",
    "addedAdjusted": "Importi adeguati alla tua decisione sui prodotti aggiunti da Ada-quote. La decisione viene inviata ad Ada-quote nelle note dell’ordine.",
    "addedPriceInvalid": "Indica un prezzo valido (ad esempio 25 o 25,50).",
    "totalsTitle": "Riepilogo economico",
    "subtotal": "Importo lordo",
    "discount": "Sconto totale",
    "netSubtotal": "Subtotale netto",
    "tax": "Imposte",
    "total": "Totale",
    "quoteReference": "Preventivo",
    "continue": "Verificato, continua alla conferma",
    "ready": "Valorizzazione ricevuta. Controlla gli importi prima di continuare.",
    "waiting": "Una valorizzazione valida deve essere disponibile e verificata prima della conferma."
  },
  "errors": {
    "valuationUncertain": "Non è stato possibile confermare il risultato. Il tentativo viene conservato e non sarà reinviato automaticamente.",
    "valuationIntegrationPending": "La valorizzazione è in attesa dell’integrazione con Ada-quote. Non sono ancora disponibili prezzi per questo ordine.",
    "valuationUnavailable": "Non è possibile consultare la valorizzazione adesso. Riprova.",
    "valuationInvalid": "La valorizzazione non corrisponde all’elenco o contiene dati economici non validi.",
    "valuationChanged": "La valorizzazione o l’elenco sono cambiati. Aggiorna e controlla nuovamente gli importi.",
    "valuationAdditionalLinesPending": "Decidi se mantenere i prodotti aggiunti da Ada-quote prima di continuare.",
    "valuationNotApplicable": "Questo passaggio è disponibile solo per richieste con cliente assegnato.",
    "valuationReviewRequired": "Ottieni e controlla una valorizzazione valida prima di confermare l’ordine.",
    "requesterEmailUnavailable": "Non è possibile verificare l’e-mail dell’utente che richiede l’invio. Controlla il suo account prima di continuare.",
    "customerAssignmentNotEnabled": "I dati dell’ordine sono salvati. L’invio commerciale è in attesa dell’integrazione Ada-quote.",
    "customerAssignmentUnavailable": "L’assegnazione dei clienti non è ancora abilitata in questo ambiente.",
    "customerAssignmentChanged": "I dati del cliente sono cambiati. Cerca e seleziona di nuovo il cliente e il suo indirizzo prima di salvare.",
    "customerAssignmentAddressInvalid": "L’indirizzo selezionato non appartiene a questo cliente o non è più disponibile.",
    "deliveryDateInPast": "La data di consegna non può essere precedente a oggi.",
    "customerAssignmentIncomplete": "Seleziona un cliente e il suo indirizzo di consegna prima di salvare i dati dell’ordine.",
    "customerAssignmentRequired": "Scegli il cliente e il suo indirizzo di consegna per creare la richiesta.",
    "customerDirectoryUnavailable": "L’anagrafica clienti di Atlas non è disponibile.",
    "customerDirectoryChanged": "L’anagrafica clienti è cambiata. Seleziona di nuovo il cliente e l’indirizzo prima di salvare le modifiche.",
    "customerDirectoryNotFound": "Atlas non trova il cliente o il percorso di consultazione.",
    "customerDirectoryInvalid": "Atlas ha restituito una risposta clienti non valida.",
    "atlasTestUnavailable": "Atlas Test non è disponibile o la connessione è cambiata. Non verrà usata automaticamente un’altra API.",
    "atlasTestIdentity": "Il server non conferma l’identità Atlas Test. Verifica la configurazione prima dell’analisi.",
    "atlasTestFormatUnsupported": "Atlas Test non conferma ancora il supporto per tutti i formati di questa richiesta.",
    "atlasTestCommercialDisabled": "Questa richiesta appartiene ad Atlas Test e non può inviare preventivi o ordini.",
    "installationVerificationRequired": "Atlas deve verificare l’elenco attuale prima della conferma della richiesta.",
    "installationInvalidResponse": "La proposta restituita da Atlas non può essere convalidata. Nessun materiale è stato inviato.",
    "installationUnavailable": "La pianificazione degli impianti non è ancora disponibile su questa connessione Atlas. La descrizione è stata salvata.",
    "installationFailed": "Atlas non ha completato questa operazione. Puoi riprovare senza inviare il preventivo.",
    "installationChanged": "La richiesta o la verifica di Atlas è cambiata. Aggiorna la pagina per continuare con la versione attuale.",
    "installationRequiresEmptyDraft": "Questo metodo richiede una richiesta senza documenti o materiali di un altro metodo. Conserva questa richiesta e creane una nuova.",
    "installationCatalogChanged": "Un prodotto o la sua unità non corrisponde più al catalogo attuale. Controlla la selezione prima di continuare.",
    "identityOptionsChanged": "Atlas ha aggiornato le alternative. Controlla le opzioni attuali e scegli di nuovo.",
    "identitySelectionRequired": "Seleziona un’alternativa di Atlas oppure indica che nessuna corrisponde.",
    "catalogProductRequired": "Scegli un prodotto del catalogo per sostituire il suggerimento di Atlas.",
    "mandatoryDependenciesInvalid": "Le licenze non sono state applicate: risposta non valida o proposta modificata. Ripeti l’analisi.",
    "pendingUnits": "Alcune unità richiedono conferma.",
    "pendingQuantities": "Alcune quantità sono ancora da definire. Verificale prima di proseguire con il preventivo.",
    "unitProvenanceProtected": "Queste righe conservano le unità del documento originale. Modificale singolarmente; l’elenco completo non può essere sostituito in modalità manuale.",
    "adaQuoteCustomerDataMissing": "Atlas richiede i dati completi del cliente prima dell’invio ad AdaQuote.",
    "submissionRetryUnsafe": "Impossibile reinviare senza confermare che AdaQuote non abbia ricevuto la richiesta. Aggiorna lo stato.",
    "submissionChecking": "Verifica del reinvio. Aggiorna lo stato prima di riprovare.",
    "accountBlocked": "Il tuo account non è attivo. Contatta Adaltra.",
    "accountPending": "Il tuo account è in attesa di convalida da parte di Adaltra. Ti avviseremo via e-mail.",
    "assistantDisabled": "L’assistente è disattivato in questo ambiente.",
    "assistantFailed": "L’assistente non è riuscito a rispondere. Riprova.",
    "assistantSessionLost": "Questa conversazione non è più disponibile.",
    "assistantTimeout": "L’assistente ha impiegato troppo tempo a rispondere.",
    "assistantUnavailable": "Non siamo riusciti a contattare l’assistente.",
    "badRequest": "La richiesta non è valida.",
    "badSignature": "La firma non è valida.",
    "budgetExpired": "Il preventivo è scaduto e non può essere approvato.",
    "budgetNotExtendable": "Questo preventivo non è più prorogabile.",
    "budgetNotFound": "Non abbiamo trovato questo preventivo.",
    "budgetNotRemindable": "Questo preventivo non è in attesa di una decisione.",
    "companyEditForbidden": "Solo il responsabile dell'account può modificare questi dati.",
    "companyNotFound": "Non abbiamo trovato l'azienda.",
    "conflict": "L'operazione non può essere completata in questo momento.",
    "conversationNotFound": "Questa conversazione non è più disponibile.",
    "currentPasswordInvalid": "La password attuale non è corretta.",
    "documentNotReady": "Il documento non è ancora disponibile.",
    "duplicate": "Questo elemento esiste già.",
    "emailAlreadyRegistered": "Questa e-mail è già registrata.",
    "fileNotFound": "Non abbiamo trovato il file.",
    "fileTooLarge": "Il file supera la dimensione massima consentita.",
    "documentInvalid": "Uno dei file è danneggiato o non corrisponde alla sua estensione, quindi Atlas non può leggerlo. Aprilo, salvalo di nuovo (o esportalo di nuovo in PDF/Excel) e caricalo di nuovo.",
    "documentUnsupported": "Atlas non può leggere uno dei file a causa del suo tipo. Caricalo come PDF, Excel (XLSX/XLS), CSV o immagine.",
    "documentEmpty": "Uno dei file è vuoto. Controlla il file e caricalo di nuovo.",
    "forbidden": "Non hai i permessi per eseguire questa azione.",
    "genericText": "Abbiamo registrato il problema. Puoi riprovare.",
    "releaseNotFound": "Non abbiamo trovato la release.",
    "platformRequestNotFound": "Non abbiamo trovato la richiesta di miglioramento.",
    "genericTitle": "Qualcosa è andato storto",
    "hermesDisabled": "L’integrazione con Atlas è disattivata.",
    "hermesIncomplete": "Inserisci l’indirizzo e la chiave API prima di attivarla.",
    "smtpIncomplete": "Configura un URL SMTP o un server prima di attivare l’e-mail.",
    "smtpNotConfigured": "Il servizio SMTP non è configurato o è disattivato.",
    "emailAudienceEmpty": "Non ci sono utenti attivi con il ruolo selezionato.",
    "pushIncomplete": "Configura le chiavi VAPID e il contatto del servizio prima di attivare le notifiche push.",
    "hermesNotReady": "L’integrazione con Atlas non è configurata.",
    "hermesRejected": "Atlas ha rifiutato il lavoro.",
    "hermesRequestRefAlreadySubmitted": "Questo numero è già stato utilizzato per un’altra richiesta in AdaQuote. Il tuo elenco è salvato e necessita di un nuovo numero per essere inviato.",
    "hermesRequestRefConflict": "Atlas ha già un altro elenco collegato a questo numero di richiesta. I materiali sono salvati; contatta Adaltra per verificare l’invio.",
    "recognitionUpdatedConcurrently": "La richiesta è stata aggiornata in un'altra sessione. Chiudi questo modulo e ricarica la pagina prima di continuare.",
    "documentReviewChanged": "La revisione o il catalogo Atlas è cambiato. Ricarica la richiesta e controlla l’elenco prima di continuare.",
    "documentReviewRejected": "Atlas non ha potuto accettare la conferma dell’elenco. I prodotti sono conservati. È necessario verificare l’integrazione.",
    "hermesTimeout": "Atlas non ha risposto in tempo.",
    "hermesUnreachable": "Impossibile connettersi a Atlas.",
    "invalidCredentials": "L'e-mail o la password non sono corrette.",
    "invalidEmail": "L'indirizzo e-mail non è valido.",
    "invalidIdentifier": "L'identificativo non è valido.",
    "invalidProductReference": "Il riferimento del prodotto non è valido.",
    "invalidQuantity": "La quantità non è valida.",
    "invalidTransition": "Questa azione non è possibile nello stato attuale.",
    "lineNotFound": "Non abbiamo trovato questa riga.",
    "includedComponentReadOnly": "Questo componente è incluso. Modifica il rack padre per aggiornarne la quantità.",
    "includedComponentUnbound": "Una riga ACC SRP non ha un rack padre verificato. È necessaria una revisione esplicita prima di continuare.",
    "invalidEquivalenceConfirmation": "Questa riga non contiene un’equivalenza che può essere convalidata.",
    "network": "Non siamo riusciti a contattare il server. Controlla la connessione.",
    "serviceUnavailable": "Il servizio si sta ripristinando. Attendi qualche secondo e riprova.",
    "noFilesProvided": "Aggiungi almeno un file.",
    "noFilesToProcess": "Aggiungi almeno un documento prima di elaborare.",
    "noLinesToSubmit": "Aggiungi almeno una riga prima di inviare.",
    "pendingProducts": "Identifica tutti i prodotti in sospeso prima di continuare.",
    "pendingAtlasSuggestions": "Conferma, cambia o rimuovi i prodotti suggeriti da Atlas prima di continuare.",
    "documentReviewPending": "Completa la revisione delle letture del documento prima di continuare.",
    "pendingEquivalences": "Convalida le equivalenze proposte prima di continuare.",
    "notFound": "Non abbiamo trovato quello che cercavi.",
    "notificationNotFound": "Non abbiamo trovato questa notifica.",
    "pushNotConfigured": "Le notifiche push non sono configurate sul server.",
    "oauthEmailNotVerified": "L'e-mail di questo account non è verificata.",
    "oauthFailed": "Non siamo riusciti a completare l'accesso. Riprova.",
    "oauthNoEmail": "Il provider non ha fornito un indirizzo e-mail.",
    "oauthSessionLost": "La sessione di accesso è scaduta. Riprova.",
    "onlyDraftsCanBeDeleted": "Si possono eliminare solo le bozze.",
    "onlyDraftsOrCancelledCanBeDeleted": "Si possono eliminare solo le bozze o le richieste annullate.",
    "requestNotCancelled": "La richiesta non è annullata.",
    "cancellationExpired": "Il termine per riattivare la richiesta è scaduto.",
    "cancellationCannotBeUndone": "Questa cancellazione non può essere annullata.",
    "pageNotFoundText": "Il link che hai seguito non esiste o è cambiato.",
    "pageNotFoundTitle": "Pagina non trovata",
    "passwordTooLong": "La password è troppo lunga.",
    "passwordTooShort": "La password deve avere almeno 10 caratteri.",
    "passwordTooSimple": "La password deve contenere lettere e numeri.",
    "passwordsDontMatch": "Le password non coincidono.",
    "productImageNotFound": "Questo prodotto non ha un’immagine disponibile.",
    "providerNotConfigured": "Questo metodo di accesso non è disponibile al momento.",
    "registrationAlreadyReviewed": "Questa richiesta di registrazione è già stata esaminata.",
    "registrationNotFound": "Non abbiamo trovato questa richiesta di registrazione.",
    "requestNotEditable": "Questa richiesta non è più modificabile.",
    "requestNotFound": "Non abbiamo trovato questa richiesta.",
    "requiredField": "Questo campo è obbligatorio.",
    "resetLinkInvalid": "Il link è scaduto o è già stato usato.",
    "routeNotFound": "Questo indirizzo non esiste.",
    "ticketNotFound": "Non abbiamo trovato il ticket.",
    "tooManyAttempts": "Troppi tentativi. Attendi qualche minuto e riprova.",
    "tooManyFiles": "Hai raggiunto il numero massimo di file.",
    "tooManyMessages": "Hai inviato troppi messaggi di seguito. Attendi un momento.",
    "unauthorized": "La sessione è scaduta. Accedi di nuovo.",
    "unexpected": "Si è verificato un errore imprevisto. Riprova.",
    "userNotFound": "Utente non trovato.",
    "cannotModifyOwnAccess": "Non puoi rimuovere il tuo stesso accesso da amministratore.",
    "unknownProvider": "Questo metodo di accesso non esiste.",
    "unsupportedFileType": "Questo tipo di file non è supportato.",
    "uploadFailed": "Non siamo riusciti a caricare il file.",
    "upstream": "Un servizio esterno non ha risposto correttamente.",
    "validUntilMustBeFuture": "La nuova data deve essere futura.",
    "validation": "Controlla i dati inseriti.",
    "adaQuoteIncomplete": "Inserisci l’indirizzo e la chiave prima di attivarla.",
    "adaQuoteCustomerCodeMissing": "Nei dati dell’azienda manca il codice cliente AdaQuote.",
    "adaQuoteReadFailed": "Non è stato possibile recuperare i preventivi da Ada-quote. Riprova.",
    "adaQuotePdfNotReady": "Il PDF di questo preventivo non è ancora disponibile. Riprova più tardi o contatta l’amministrazione.",
    "adaQuotePdfCustomerMismatch": "Il preventivo non corrisponde al codice cliente di questa richiesta. Contatta l’amministrazione.",
    "adaQuotePdfUnavailable": "Impossibile recuperare il PDF del preventivo. Riprova.",
    "adaQuotePdfInvalid": "Non è stato ricevuto un PDF valido.",
    "atlasPdfUnavailable": "Atlas non può ancora fornire il PDF del preventivo. Riprova più tardi.",
    "atlasPdfIdentityConflict": "Atlas ha restituito un’identità del preventivo diversa. Il documento non verrà mostrato; contatta l’amministrazione.",
    "adaQuotePdfNotValidated": "Il PDF sarà disponibile dopo la validazione commerciale.",
    "hermesSignatureRequired": "L’invio automatico richiede il segreto di firma.",
    "catalogMasterChanged": "Il master tariffario è cambiato durante la copia. Riprova.",
    "catalogTooManyPages": "La copia del catalogo non termina. Controlla la connessione con Atlas.",
    "catalogNoVersion": "Atlas non ha indicato quale versione del master ha.",
    "catalogProductUnavailable": "Il prodotto selezionato non è più disponibile nel catalogo. Aggiorna le opzioni e riprova.",
    "recognitionUnusable": "Atlas ha restituito un risultato che il portale non ha potuto salvare. Riprova.",
    "recognitionVisualAnalysisUnavailable": "L’analisi visiva di Atlas non è al momento disponibile. I tuoi file sono salvati; puoi riprovare più tardi senza sostituirli.",
    "recognitionFailed": "Il riconoscimento è fallito.",
    "documentAnalysisUnavailable": "Atlas non ha potuto avviare l’analisi. I file sono salvati; puoi riprovare più tardi senza caricarli di nuovo.",
    "recommendationsRejected": "Atlas non ha potuto avviare l’analisi dei suggerimenti.",
    "recommendationsNeedRecognition": "Questo elenco non ha ancora un risultato che Atlas possa analizzare.",
    "recommendationsNotReady": "I suggerimenti non sono ancora pronti.",
    "recommendationNotFound": "Questo suggerimento non è più disponibile.",
    "recommendationAlreadyDecided": "Questo suggerimento è già stato esaminato.",
    "recommendationNeedsInput": "Rispondi prima alle domande in sospeso.",
    "recommendationMissingProduct": "Atlas non ha associato un prodotto valido al suggerimento.",
    "recommendationCatalogStale": "Il catalogo è cambiato. Ripeti l’analisi.",
    "recommendationReplacementMissing": "Atlas non ha indicato quale prodotto sostituire. Ripeti l’analisi.",
    "recommendationsPending": "Esamina i suggerimenti Atlas prima dell’invio.",
    "recommendationQuestionsPending": "Rispondi alle domande Atlas prima di continuare.",
    "recommendationDecisionsPending": "Aggiungi o scarta ogni suggerimento prima di continuare.",
    "unitReviewChanged": "La riga è cambiata dopo l’apertura. Ricarica la richiesta e verifica nuovamente l’unità.",
    "unitAnswerUnresolved": "Atlas non ha confermato l’unità scelta. La domanda resta in sospeso; la selezione non è stata applicata.",
    "quantityAnswerUnresolved": "Atlas non ha ancora applicato la quantità inserita. La verifica resta in sospeso; riprova.",
    "installationReferenceSize": "I file di riferimento possono occupare fino a 10 MB ciascuno e 20 MB in totale.",
    "installationReferenceInvalid": "Impossibile leggere il file di riferimento. Verifica che il PDF o l’immagine sia valido.",
    "installationReferenceLocked": "Per modificare i file, torna alla descrizione e avvia una nuova analisi.",
    "installationReferencesUnavailable": "Questa connessione Atlas non supporta ancora i file di riferimento. I file e la descrizione sono salvati.",
    "requestChangedConcurrently": "La richiesta è cambiata mentre salvavi. Aggiorna la pagina e riprova.",
    "semanticResolutionFailed": "Atlas non ha potuto completare l'interpretazione. Riprova o controlla il documento.",
    "visualReviewConfirmationRequired": "Atlas non considera ancora confermata la lettura della foto. Usa «Rianalizza» nel menu della richiesta per rileggerla e confermarla.",
    "readingConnectionChanged": "La connessione di lettura di questa richiesta è cambiata. L'analisi non verrà inviata a un'altra destinazione.",
    "simpleReadingUnavailable": "La lettura semplificata non è disponibile. La richiesta non passerà automaticamente a un'altra connessione.",
    "simpleReadingFormatUnsupported": "La lettura semplificata accetta PDF e immagini; questo tipo di file non è ancora disponibile.",
    "simpleReadingImagesUnchecked": "Non è stato possibile verificare se Atlas legge le immagini. I tuoi file sono ancora salvati; riprova.",
    "simpleReadingImagesDisabled": "Atlas non legge ancora le immagini nella lettura semplificata. La tua foto è ancora salvata; potrai analizzarla quando sarà disponibile.",
    "readingConnectionLocked": "Questa richiesta è già collegata alla sua connessione di lettura. Crea un'altra richiesta per confrontare.",
    "processingRequestChanged": "La richiesta è cambiata. Aggiorna la pagina prima di analizzare.",
    "recognitionJobGone": "Atlas non ha più questa analisi. I tuoi file sono ancora salvati; analizzali di nuovo.",
    "recognitionServiceUnavailable": "Atlas non risponde su questa analisi da alcuni minuti. I tuoi file sono ancora salvati; riprova più tardi.",
    "recognitionStartInterrupted": "Non è stato possibile confermare l’avvio dell’analisi. I tuoi file sono ancora salvati; analizzali di nuovo.",
    "recognitionNotRestarted": "Atlas non ha avviato una nuova lettura perché conserva ancora quella precedente. Attendi qualche minuto e analizza di nuovo.",
    "typedTextEmpty": "Scrivi prima il tuo elenco o la descrizione del tuo impianto.",
    "typedTextInvalidCharacters": "Il testo contiene caratteri che Atlas non può leggere (ad esempio caratteri di controllo incollati da un altro programma). Rimuovili e invialo di nuovo.",
    "typedTextTooLarge": "Il testo è troppo lungo perché Atlas lo legga in una volta (massimo 4.000 caratteri e 16 KB). Accorcialo o dividilo in più richieste.",
    "typedTextTooManyLines": "Il testo ha troppe righe perché Atlas lo legga in una volta (massimo 300). Raggruppa le righe o dividilo in più richieste.",
    "typedTextRequiresOneFile": "Atlas legge il testo scritto da solo, senza altri documenti. Rimuovi i documenti o invia il testo in un’altra richiesta.",
    "typedTextNoMaterials": "Atlas non ha trovato alcun prodotto nel testo. Controllalo (ad esempio «20 prese cat6») o descrivilo come un impianto.",
    "typedTextUnsupported": "Questa connessione di Atlas non legge ancora i testi scritti come elenco. Invia la descrizione come impianto o compila l’elenco manualmente.",
    "twoFactorInvalid": "Codice errato. Riprova.",
    "twoFactorExpired": "Il codice è scaduto o è già stato usato. Accedi di nuovo.",
    "twoFactorLocked": "Troppi tentativi. Attendi 15 minuti prima di riprovare.",
    "twoFactorResendWait": "Attendi prima di richiedere un altro codice. Se hai esaurito gli invii, accedi di nuovo.",
    "twoFactorDelivery": "Impossibile inviare il codice via email. Riprova più tardi.",
    "closedOrderRecommendationsDisabled": "Gli ordini definitivi passano da Revisione a Conferma senza raccomandazioni.",
    "wordConverterUnavailable": "La conversione da Word a PDF non è disponibile. Carica un PDF o riprova più tardi.",
    "wordConversionFailed": "Impossibile convertire il documento Word in PDF. Verifica che non sia danneggiato o protetto da password, oppure caricalo come PDF.",
    "resetRequiresActiveUser": "Il cambio password può essere richiesto solo per account attivi.",
    "passwordChangeRequired": "Un amministratore richiede un cambio password. Apri il link ricevuto via email oppure richiedine uno da Password dimenticata per accedere nuovamente.",
    "cannotForceOwnPasswordReset": "Cambia la tua password dal profilo.",
    "passwordResetCooldown": "Attendi un minuto prima di inviare un’altra email.",
    "passwordResetEmailFailed": "Impossibile inviare l’email. L’account non è stato bloccato; verifica le impostazioni email e riprova.",
    "cannotDeleteOwnUser": "Non puoi eliminare il tuo account.",
    "userSecurityChanged": "L’account è cambiato durante l’operazione. Aggiorna l’elenco e riprova.",
    "customerOrderRequired": "Le richieste con cliente assegnato si inviano con «Vinto e passa a ordine».",
    "customerOrderUnavailable": "Il passaggio a ordine non è ancora disponibile in Atlas.",
    "customerOrderInvalid": "Atlas ha restituito una risposta d’ordine non valida.",
    "customerOrderConflict": "La richiesta è cambiata. Ricarica e riprova.",
    "customerOrderUnreachable": "Impossibile contattare Atlas. Puoi riprovare: l’ordine non verrà duplicato.",
    "customerOrderNotApplicable": "Questa richiesta non ha un cliente assegnato.",
    "customerOrderDataMissing": "Per passare a ordine mancano la data di consegna o il numero d’ordine del cliente (passo 1).",
    "atlasMaintenance": "Atlas è in manutenzione. La richiesta è in coda e verrà elaborata automaticamente al termine."
  },
  "help": {
    "title": "Centro assistenza",
    "subtitle": "Risposte sul portale e sul processo di preventivazione.",
    "guides": "Guide",
    "faq": "Domande frequenti",
    "contactTitle": "Ti serve aiuto?",
    "contactText": "Spiega cosa è successo e indica il riferimento della richiesta o del preventivo, se disponibile.",
    "contactCta": "Contatta il supporto",
    "guidePhotoTitle": "Come scattare una buona foto",
    "guidePhotoIntro": "Ottieni un riconoscimento più preciso preparando bene ogni immagine.",
    "guidePhotoStep1": "Appoggia l'elenco su una superficie piana e ben illuminata.",
    "guidePhotoStep2": "Inquadra il foglio intero, senza tagliare riferimenti o quantità.",
    "guidePhotoStep3": "Evita riflessi, ombre e foto inclinate.",
    "guidePhotoStep4": "Controlla che il testo sia leggibile prima di proseguire.",
    "guidePhotoTip": "Se le pagine sono più di una, fotografale in ordine. Potrai controllarle tutte prima dell'elaborazione.",
    "guideLinesTitle": "Come correggere gli articoli",
    "guideLinesIntro": "Controlla la lettura del documento e il prodotto selezionato prima di inviare l’elenco.",
    "guideLinesStep1": "Se compaiono Letture da confermare, controlla testo, quantità e unità di ogni riga. Usa modifica per correggerli e conferma per salvare la lettura.",
    "guideLinesStep2": "Confermare il testo non identifica sempre il prodotto. Se Atlas chiede un riferimento, rispondi alla domanda o cerca il prodotto nel catalogo per codice o riferimento.",
    "guideLinesStep3": "Nell’elenco dei materiali, controlla prodotto, quantità e unità. Apri modifica per cambiare la riga e conferma quelle che richiedono la tua validazione.",
    "guideLinesStep4": "Rimuovi o escludi i materiali indesiderati quando la schermata lo consente. Risolvi le quantità o unità in sospeso prima di continuare.",
    "guideLinesTip": "Un riferimento riconosciuto correttamente non sostituisce il controllo della quantità e dell’unità. Verifica, ad esempio, se un cavo è richiesto in metri o in pezzi.",
    "guideBudgetTitle": "Come nasce il preventivo",
    "guideBudgetIntro": "Scopri il percorso dal tuo elenco alla proposta commerciale.",
    "guideBudgetStep1": "Controlla materiali, quantità e unità. Rispondi alle domande di Atlas in sospeso e decidi sui suggerimenti mostrati.",
    "guideBudgetStep2": "Alla conferma, verifica il riepilogo e seleziona la casella di revisione dei materiali e delle quantità. Premi Invia richiesta per richiedere il preventivo.",
    "guideBudgetStep3": "Controlla l’avanzamento in Le mie richieste e nelle notifiche. Quando il preventivo è disponibile, aprilo da Preventivi.",
    "guideBudgetStep4": "Controlla prezzi e condizioni. Scarica il documento quando disponibile e usa le azioni di approvazione, modifica o rifiuto offerte dal preventivo.",
    "guideBudgetTip": "L’importo mostrato prima dell’invio è una stima. Controlla prezzi e condizioni del preventivo generato prima di approvarlo.",
    "guidePrivacyTitle": "Privacy dei tuoi documenti",
    "guidePrivacyIntro": "I tuoi file servono esclusivamente a gestire la richiesta.",
    "guidePrivacyStep1": "I documenti restano collegati al tuo account cliente.",
    "guidePrivacyStep2": "Solo il personale autorizzato può consultarne il contenuto.",
    "guidePrivacyStep3": "Puoi chiedere informazioni sulla conservazione o sulla cancellazione.",
    "guidePrivacyStep4": "Non condividiamo i tuoi file per finalità pubblicitarie.",
    "guidePrivacyTip": "Consulta l'informativa completa sulla privacy per saperne di più.",
    "faqTimeQ": "Quanto tempo serve per ricevere il preventivo?",
    "faqTimeA": "I tempi dipendono dall’analisi e dalle verifiche necessarie. Puoi controllare lo stato in Le mie richieste; riceverai una notifica quando ci sono novità.",
    "faqEditQ": "Posso modificare una richiesta già inviata?",
    "faqEditA": "Dopo l'invio non è più modificabile, ma puoi scrivere al supporto indicando il riferimento.",
    "faqFormatsQ": "Quali formati di file posso caricare?",
    "faqFormatsA": "Puoi caricare immagini JPG, PNG, WEBP o HEIC, PDF e fogli XLSX, XLS o CSV. Sono ammessi più file per richiesta; verifica che siano tutti allegati prima dell’analisi.",
    "faqPriceQ": "I prezzi comprendono l'IVA?",
    "faqPriceA": "Il dettaglio mostra separatamente l'imponibile e l'IVA, oltre al totale comprensivo di imposte.",
    "shortcuts": "Accessi rapidi",
    "privacyAction": "Leggi l’informativa sulla privacy",
    "guideStartTitle": "Come creare una richiesta",
    "guideStartIntro": "Scegli il metodo adatto alle informazioni che hai.",
    "guideStartStep1": "Seleziona Nuova richiesta e inserisci i dati del progetto. Conserva il riferimento SOL per ritrovarlo.",
    "guideStartStep2": "Se hai un elenco, scatta una foto o carica PDF, immagini, Excel o CSV. Puoi allegare più file, ad esempio un PDF e un’immagine.",
    "guideStartStep3": "Se conosci i prodotti, scegli l’inserimento manuale e cercali per codice o riferimento. Per far proporre i materiali ad Atlas, scegli Descrivi la tua installazione ad Atlas.",
    "guideStartStep4": "Controlla i materiali e i suggerimenti. Alla conferma finale, verifica il riepilogo, seleziona la casella di revisione dell’elenco e premi Invia richiesta.",
    "guideStartTip": "Inviare una descrizione o caricare un file avvia l’analisi. L’invio finale della richiesta avviene dopo la tua revisione.",
    "guideAtlasTitle": "Descrivi la tua installazione ad Atlas",
    "guideAtlasIntro": "Spiega cosa ti serve e verifica i materiali proposti da Atlas.",
    "guideAtlasStep1": "In una nuova richiesta, seleziona Descrivi la tua installazione ad Atlas. Indica l’obiettivo, le zone o i piani, le quantità previste e le apparecchiature o i cavi già presenti. Puoi anche allegare planimetrie, foto o PDF come riferimento.",
    "guideAtlasStep2": "Premi Invia proposta. Se mancano dettagli, apri ogni argomento, rispondi ai passaggi della finestra e salva le risposte. Completati gli argomenti, premi Invia risposte.",
    "guideAtlasStep3": "Quando la proposta è pronta, controlla codice, riferimento, descrizione e quantità di ogni materiale. Puoi confermare, modificare dal catalogo o rimuovere righe.",
    "guideAtlasStep4": "Leggi la spiegazione dei componenti e i suggerimenti di Atlas. Scegli cosa aggiungere e attendi la fine della verifica tecnica; eventuali domande residue appariranno nel portale.",
    "guideAtlasStep5": "Alla conferma, controlla l’elenco e l’importo disponibile. Seleziona la casella di revisione dei materiali e delle quantità e premi Invia richiesta.",
    "guideAtlasTip": "I materiali provvisori sono un’anteprima. Le azioni saranno disponibili quando Atlas avrà completato le verifiche; puoi uscire e riprendere la richiesta.",
    "guideResumeTitle": "Come riprendere una richiesta",
    "guideResumeIntro": "Continua una revisione salvata e controlla cosa è in sospeso.",
    "guideResumeStep1": "Durante l’analisi, usa Esci o Esci e continua più tardi. Apri Le mie richieste e seleziona il riferimento SOL per riprendere il passaggio in sospeso.",
    "guideResumeStep2": "Se Atlas sta elaborando o eseguendo verifiche tecniche, attendi e controlla lo stato. Un’anteprima dei materiali non significa che la proposta sia pronta da confermare.",
    "guideResumeStep3": "Completa le domande, letture, quantità o unità in sospeso indicate sullo schermo. Controlla anche le notifiche per gli aggiornamenti.",
    "guideResumeStep4": "Se compare un errore, usa Riprova quando disponibile. Se persiste, contatta l’assistenza indicando riferimento, passaggio e cosa è successo; uno screenshot aiuta.",
    "guideResumeTip": "Salva le risposte o le modifiche prima di uscire da una finestra. Verifica che le conferme siano state salvate prima di chiudere la schermata.",
    "faqReadingQ": "Perché devo confermare una lettura?",
    "faqReadingA": "Atlas può richiedere di validare testo, quantità o unità del documento. Confermare la lettura salva questi dati; se il prodotto deve ancora essere identificato, apparirà una domanda per selezionarlo.",
    "faqSavedQ": "Posso uscire mentre Atlas lavora?",
    "faqSavedA": "Sì. La richiesta viene salvata e puoi riprenderla da Le mie richieste. Prima salva le modifiche delle finestre e attendi il completamento delle conferme in corso.",
    "faqPendingQ": "Cosa significa In attesa di Atlas?",
    "faqPendingA": "Atlas sta ancora completando l’analisi o le verifiche. Se non ci sono domande per te, controlla lo stato più tardi. I materiali provvisori non sono validabili finché la proposta non è pronta.",
    "faqUnavailableQ": "Perché un collegamento indica che la richiesta o il preventivo non è disponibile?",
    "faqUnavailableA": "L’elemento potrebbe essere stato eliminato o il collegamento essere errato. Torna all’elenco per trovarlo. Se ti aspettavi l’accesso e non compare, contatta l’assistenza indicando il riferimento."
  },
  "languages": {
    "es": "Español",
    "en": "English",
    "fr": "Français",
    "it": "Italiano"
  },
  "lineConfidence": {
    "high": "Riconoscimento affidabile",
    "review": "Riferimento da verificare",
    "incomplete": "Dato incompleto",
    "corrected": "Corretta da te",
    "confirmed": "Confermato",
    "manual": "Inserita manualmente"
  },
  "nav": {
    "home": "Home",
    "newRequest": "Nuova richiesta",
    "requests": "Richieste",
    "budgets": "Preventivi",
    "assistant": "Assistente Atlas",
    "admin": "Amministrazione",
    "notifications": "Notifiche",
    "help": "Assistenza",
    "profile": "Profilo",
    "support": "Supporto",
    "privacy": "Privacy",
    "signOut": "Esci",
    "signingOut": "Disconnessione…",
    "mobileNew": "Nuova",
    "mobileHome": "Home",
    "mobileRequests": "Richieste",
    "mobileBudgets": "Preventivi",
    "mobileAssistant": "Assistente",
    "mobileProfile": "Profilo",
    "changeLanguage": "Cambia lingua",
    "mainNavigation": "Navigazione principale",
    "mobileNavigation": "Navigazione mobile",
    "hideSidebar": "Riduci il menu",
    "showSidebar": "Espandi il menu",
    "preferences": "Preferenze",
    "legalNotice": "Note legali",
    "cookies": "Cookie",
    "legalInformation": "Informazioni legali"
  },
  "notifications": {
    "budgetApprovedBody": "Hai approvato {{ref}} · {{project}}. Adaltra prepara l’ordine.",
    "budgetApprovedTitle": "Preventivo approvato",
    "budgetChangesBody": "Adaltra rivedrà {{ref}} · {{project}} e ti invierà una proposta corretta.",
    "budgetChangesTitle": "Modifiche richieste",
    "budgetExpiringBody": "Approvalo prima della data di validità.",
    "budgetExpiringTitle": "Il preventivo {{ref}} sta per scadere",
    "budgetExtendedBody": "Abbiamo prorogato la validità di {{ref}}. Ora hai più tempo per decidere.",
    "budgetExtendedTitle": "Preventivo prorogato",
    "budgetReadyBody": "Ora puoi consultarlo e scaricarlo.",
    "budgetReadyTitle": "Il preventivo {{ref}} è pronto",
    "budgetRejectedBody": "Hai rifiutato {{ref}} · {{project}}.",
    "budgetRejectedTitle": "Preventivo rifiutato",
    "budgetReminderBody": "{{ref}} è ancora in attesa della tua decisione.",
    "budgetReminderTitle": "Un preventivo ti aspetta",
    "budgetWithdrawnBody": "{{ref}} non è più disponibile. Scrivici se ti interessa ancora.",
    "budgetWithdrawnTitle": "Preventivo ritirato",
    "emptyText": "Ti avviseremo qui quando ci saranno novità.",
    "emptyTitle": "Non hai notifiche",
    "markAllRead": "Segna tutte come lette",
    "panelError": "Non siamo riusciti a caricare le notifiche.",
    "panelUnread": "{{count}} non lette",
    "viewAll": "Vedi tutte le notifiche",
    "settingsButton": "Impostazioni",
    "settingsTitle": "Impostazioni delle notifiche",
    "deleteAll": "Elimina",
    "deleteConfirmText": "Verrà eliminata tutta la cronologia delle notifiche. Questa azione non può essere annullata.",
    "deleteConfirmTitle": "Eliminare tutte le notifiche?",
    "channelsTitle": "Avvisi su tutti i tuoi dispositivi",
    "channelsText": "E-mail e push seguono le tue preferenze. Attiva i push su ogni dispositivo su cui vuoi riceverli.",
    "enablePush": "Attiva push",
    "disablePush": "Disattiva push",
    "pushChecking": "Verifica push",
    "pushInactive": "Push disattivato",
    "pushBlocked": "Push bloccato",
    "pushUnavailable": "Push non disponibile",
    "channelsTextActive": "Le notifiche push sono attive su questo dispositivo e seguono le tue preferenze. Puoi disattivarle in qualsiasi momento.",
    "pushActive": "Push attivo",
    "pushEnabled": "Le notifiche push sono attive su questo dispositivo.",
    "pushDisabled": "Le notifiche push sono state disattivate su questo dispositivo.",
    "pushDenied": "Il browser sta bloccando le notifiche di Atlas.",
    "pushError": "Non è stato possibile modificare le impostazioni delle notifiche push.",
    "pushRequiresHttps": "Le notifiche push e l’installazione richiedono una connessione HTTPS sicura.",
    "pushNotConfigured": "Mancano le chiavi VAPID del server per attivare le notifiche push.",
    "emailNotConfigured": "Occorre configurare il server SMTP per inviare le e-mail.",
    "installApp": "Installa app",
    "appInstalled": "App installata",
    "installHint": "Su iPhone o iPad usa Condividi → Aggiungi alla schermata Home.",
    "quoteFailedBody": "C’è stato un problema con {{ref}}. Lo stiamo verificando.",
    "quoteFailedTitle": "Non siamo riusciti a preparare il preventivo",
    "quoteReadyBody": "{{ref}} è ora consultabile e accettabile.",
    "quoteInReviewTitle": "Il tuo preventivo è in revisione",
    "quoteInReviewBody": "{{ref}} è consultabile. Un commerciale lo sta controllando prima di inviartelo.",
    "quoteRejectedByAdaQuoteBody": "{{ref}} non ha superato la revisione commerciale.",
    "quoteRejectedByAdaQuoteTitle": "Preventivo non approvato",
    "quoteReadyTitle": "Il tuo preventivo è pronto",
    "requestProcessedBody": "Atlas ha preparato {{ref}}. Controlla i prodotti prima di inviarla.",
    "requestProcessedTitle": "Richiesta in attesa di revisione",
    "requestReadingFailedTitle": "Analisi dei documenti non riuscita",
    "requestReadingFailedBody": "Atlas non ha completato l’analisi di {{ref}}. Apri la richiesta per consultare l’errore e riprovare.",
    "requestReceivedBody": "Atlas ha iniziato a preparare il preventivo.",
    "requestReceivedTitle": "Richiesta {{ref}} ricevuta",
    "requestSubmittedBody": "{{ref}} · {{project}} è nelle mani di Atlas.",
    "requestSubmittedTitle": "Richiesta inviata",
    "subtitle": "Tutto quello che è successo alle tue richieste e ai tuoi preventivi.",
    "title": "Notifiche",
    "unread": "Non lette",
    "maintenanceQueueStartedTitle": "Richiesta inviata ad Atlas",
    "maintenanceQueueStartedBody": "La manutenzione è terminata e {{ref}} è in elaborazione.",
    "maintenanceQueueFailedTitle": "Impossibile elaborare la richiesta in coda",
    "maintenanceQueueFailedBody": "{{ref}} non è stata inviata ad Atlas dopo la manutenzione. Aprila e premi di nuovo «Analizza»."
  },
  "privacy": {
    "title": "Informativa sulla privacy",
    "subtitle": "Come trattiamo le informazioni che condividi con Adaltra.",
    "section1Title": "Dati che raccogliamo",
    "section1Text": "I dati di contatto del tuo account, quelli della tua azienda e i documenti che carichi per preparare un preventivo.",
    "section2Title": "Come li usiamo",
    "section2Text": "Solo per gestire le tue richieste, elaborare i preventivi e offrirti assistenza. Non li cediamo per finalità pubblicitarie.",
    "section3Title": "Conservazione",
    "section3Text": "Conserviamo i documenti per tutta la durata del rapporto commerciale e per i termini previsti dalla normativa fiscale.",
    "section4Title": "I tuoi diritti",
    "section4Text": "Puoi chiedere l'accesso, la rettifica o la cancellazione dei tuoi dati scrivendo al nostro team di supporto."
  },
  "profile": {
    "title": "Il tuo profilo",
    "subtitle": "Gestisci i tuoi dati e quelli della tua azienda.",
    "personalData": "Dati personali",
    "companyData": "Dati aziendali",
    "security": "Sicurezza",
    "preferences": "Preferenze",
    "language": "Lingua",
    "languageHint": "Verrà applicata a tutto il portale e alle e-mail che riceverai.",
    "address": "Indirizzo",
    "city": "Città",
    "postalCode": "CAP",
    "province": "Provincia",
    "adaQuoteCustomerCode": "Codice cliente AdaQuote",
    "adaQuoteCustomerCodeHint": "Codice commerciale assegnato alla tua azienda in AdaQuote.",
    "adaQuoteCustomerCodeReadOnlyHint": "Codice commerciale assegnato da Adaltra. Puoi visualizzarlo, ma solo un amministratore può modificarlo.",
    "linkedAccounts": "Account collegati",
    "linkedAccountsHint": "Puoi accedere al portale con uno qualsiasi di questi.",
    "companyReadOnly": "Solo il responsabile dell'account può modificare i dati fiscali. Scrivici se ti serve cambiarli.",
    "passwordChanged": "Password aggiornata",
    "session": "Sessione",
    "sessionHint": "Chiudi la sessione su questo dispositivo."
  },
  "request": {
    "dateNotPast": "Non può essere precedente a oggi.",
    "orderAssignment": {
      "previewLabel": "Disponibile",
      "savedLabel": "Salvato",
      "savedHint": "Dati salvati nella richiesta.",
      "previewHint": "Seleziona il cliente e l’indirizzo di consegna. I dati saranno salvati continuando o salvando le modifiche.",
      "retryConnection": "Riprova connessione",
      "noCustomers": "Nessun cliente corrispondente",
      "noAddresses": "Nessun indirizzo disponibile",
      "connecting": "Connessione ad Atlas…",
      "searchHint": "Digita almeno due caratteri del nome, del codice o della partita IVA.",
      "sourceCount": "Clienti disponibili in Atlas: {{count}}",
      "staleCopy": "Copia in attesa di aggiornamento",
      "previewSummaryHint": "Il riepilogo si aggiorna compilando i campi e viene salvato con la richiesta.",
      "summaryAddress": "Indirizzo",
      "summaryDate": "Data di consegna",
      "summaryOrderNumber": "Numero ordine",
      "summaryCustomer": "Cliente",
      "title": "Assegna cliente e indirizzo di consegna",
      "soon": "Prossimamente",
      "hint": "La selezione di clienti e indirizzi sarà attivata quando sarà disponibile l’anagrafica Atlas.",
      "customer": "Cerca cliente (nome, codice o partita IVA)",
      "taxId": "P. IVA",
      "customerHint": "Clienti importati da Atlas.",
      "address": "Indirizzo di consegna / spedizione (numdir)",
      "addressHint": "Seleziona prima un cliente per consultarne gli indirizzi.",
      "date": "Data di consegna (installazione)",
      "dateHint": "Data di consegna prevista.",
      "orderNumber": "Numero ordine cliente",
      "useProjectName": "Copia il nome del progetto",
      "orderHint": "Numero d’ordine del cliente.",
      "summary": "Riepilogo ordine",
      "summaryHint": "Quando questa funzione sarà attivata, i dati seguenti si aggiorneranno compilando i campi del modulo."
    },
    "atlasTestConfirmSubtitle": "Questo è l’elenco risultante dalla prova di lettura Atlas Test.",
    "readingConnectionLabel": "Connessione di lettura",
    "readingConnectionCurrent": "Atlas attuale",
    "readingConnectionSimple": "Lettura semplificata (B)",
    "readingConnectionNotReady": "in attesa di configurazione",
    "readingConnectionHelp": "Scegli la connessione prima della prima analisi. Crea richieste separate per confrontare lo stesso documento.",
    "readingConnectionLocked": "Questa richiesta conserva la connessione durante tutta l’analisi e la revisione.",
    "atlasTestNotice": "Prova di lettura. Puoi verificare i risultati; l’invio di preventivi e ordini è bloccato.",
    "mandatoryDependencyConflict": "Alcune licenze richiedono una verifica",
    "mandatoryDependencyConflictHint": "Le righe sono state conservate. Verifica le licenze e ripeti l’analisi prima di continuare.",
    "mandatoryDependencyWarning": "Atlas ha rilevato informazioni sulla copertura da verificare.",
    "confirmAllAndContinue": "Conferma tutto e continua",
    "continueRecognizedList": "Continua con questo elenco",
    "continueRecognizedListHint": "Verranno conservati i {{count}} articoli della tabella, senza aggiungere altri frammenti del documento.",
    "previousIdentificationStep": "Torna al passaggio precedente",
    "identifyAction": "Identifica",
    "identifyInTableHint": "Identifica ogni prodotto dalla sua riga. Atlas ti guiderà passo dopo passo.",
    "rackScopeHint": "Assegna ogni componente al suo rack oppure lascialo indipendente. I gruppi già definiti da Atlas non cambieranno.",
    "rackScopeChoose": "Seleziona la destinazione",
    "rackScopeIndependent": "Indipendente (senza rack)",
    "rackScopeAssigned": "Assegnazione completata",
    "rackScopeUnavailable": "Atlas deve completare i dati di questa assegnazione prima di continuare.",
    "rackScopeLine": "Componente",
    "commercialRejectionSummary": "Consulta l’esito della revisione commerciale.",
    "partialRejectionText": "La validazione è completata. Queste righe sono state rifiutate; i prodotti accettati restano nella bozza.",
    "validationCompleted": "Validazione commerciale completata",
    "validationCounts": "Prodotti accettati: {{accepted}} · Rifiutati: {{rejected}}",
    "validationDraft": "Bozza {{ref}} creata in AdaQuote. Il preventivo definitivo e i suoi prezzi non sono ancora disponibili.",
    "lineRejectedCommercially": "Rifiutato dal commerciale",
    "lineAcceptedCommercially": "Accettato dal commerciale",
    "viewRejectionReasons": "Vedi i motivi del rifiuto",
    "rejectionReasonsTitle": "Motivi del rifiuto",
    "rejectionReasonsUnavailable": "Non sono stati ricevuti ulteriori motivi.",
    "commercialRejectionText": "La richiesta non è stata approvata durante la revisione commerciale. Di seguito trovi i motivi ricevuti.",
    "rejectedLine": "Prodotto {{number}}",
    "placeOrder": "Effettua ordine",
    "adaQuotePdfTitle": "PDF del preventivo · {{number}}",
    "loadingAdaQuotePdf": "Caricamento PDF del preventivo…",
    "preparationTransition": "Apertura dello stato della richiesta tra {{count}} s.",
    "customerCodeBlockedHelp": "Un amministratore deve completare i dati del cliente. I prodotti verificati vengono conservati; il reinvio resta bloccato fino alla risoluzione.",
    "checkCustomerCode": "Verifica dati",
    "retrySubmission": "Reinvia ad Atlas",
    "recoverReference": "Recupera elenco",
    "recoveredReferenceHelp": "L’elenco ha un nuovo numero. Verifica i materiali e conferma nuovamente l’invio. I documenti restano nella richiesta originale.",
    "viewOriginalRequest": "Vedi richiesta originale",
    "customerCodeReady": "Il codice cliente è disponibile. Puoi reinviare la richiesta ad Atlas.",
    "addFile": "Aggiungi file",
    "addMoreFiles": "Aggiungi altri file",
    "addLine": "Aggiungi prodotto",
    "addLineAfterReading": "Completa la revisione delle letture del documento. Nel frattempo puoi aggiungere prodotti manualmente.",
    "addRow": "Aggiungi riga",
    "analyzingHint": "Puoi chiudere questa pagina: il lavoro prosegue da parte nostra.",
    "analyzingStepIssuing": "Emissione del preventivo",
    "analyzingStepMatching": "Incrocio dei codici",
    "analyzingStepPricing": "Applicazione dei prezzi",
    "analyzingStepReceived": "Elenco ricevuto",
    "analyzingText": "Abbiamo ricevuto il tuo elenco e lo stiamo quotando. Ti avviseremo appena il preventivo sarà pronto.",
    "analyzingTitle": "Atlas sta preparando il tuo preventivo",
    "commercialReviewHint": "Ti avviseremo al termine della revisione.",
    "commercialReviewStepAnalyzing": "Revisione commerciale in corso",
    "commercialReviewStepChecking": "Verifica di prodotti e condizioni",
    "commercialReviewStepReceived": "Ricevuto dal team commerciale",
    "commercialReviewStepValidating": "Validazione della proposta",
    "commercialReviewText": "Un commerciale sta verificando la proposta prima di inviartela.",
    "commercialReviewTitle": "Il tuo preventivo è in revisione",
    "backHome": "Torna alla home",
    "cancelDialogText": "Adaltra smetterà di lavorarci. Potrai riattivarla per 7 giorni; in seguito verrà eliminata definitivamente insieme ai documenti.",
    "cancelDialogTitle": "Annullare questa richiesta?",
    "cancelProcess": "Annulla il processo",
    "cancelProcessEmptyText": "Tornerai alla pagina iniziale. Non verrà eliminata alcuna richiesta perché non hai ancora salvato nessun dato.",
    "cancelProcessTitle": "Annullare questo processo?",
    "cancelRequest": "Annulla la richiesta",
    "cancelledMessage": "Richiesta annullata",
    "cancelledCleanupNotice": "Questa richiesta verrà eliminata automaticamente il {{date}}. Fino ad allora puoi riattivarla.",
    "cancelledCleanupList": "Verrà eliminata automaticamente il {{date}}",
    "deletePermanently": "Elimina definitivamente",
    "permanentDeleteTitle": "Eliminare definitivamente questa richiesta?",
    "permanentDeleteText": "«{{name}}» e i suoi documenti verranno eliminati ora. Non sarà più possibile riattivare la richiesta o annullare questa azione.",
    "permanentlyDeleted": "Richiesta eliminata definitivamente",
    "changeMethod": "Cambia metodo",
    "chooseMethod": "Scegli come aggiungere i prodotti. Potrai controllare e modificare l'elenco prima di richiedere il preventivo.",
    "confirmCheck": "Ho controllato l'elenco e confermo che i dati sono corretti.",
    "confirmBeforeSubmit": "Conferma di aver controllato l'elenco prima di inviare la richiesta.",
    "confirmNavigation": "Navigazione della conferma",
    "confirmPendingFooter": "Conferma l'elenco",
    "confirmReadyFooter": "Pronto per l'invio",
    "confirmSubtitle": "Questo è l'elenco che invieremo ad Atlas per preparare il preventivo.",
    "confirmTitle": "Conferma la richiesta",
    "estimatedPvpTitle": "Stima del prezzo di listino",
    "estimatedSubtotal": "Prezzo di listino IVA esclusa",
    "estimatedVat": "IVA ({{rate}}%)",
    "estimatedTotal": "Totale IVA inclusa",
    "estimatedTotalPartial": "Totale parziale IVA inclusa",
    "estimatedNoValuedLines": "Stima in attesa: non è ancora stato calcolato l’importo di alcun prodotto.",
    "estimatedPvpNote": "Totale approssimativo calcolato al prezzo di listino, senza sconti applicati.",
    "estimatedUnpricedIntro": "Prodotti con importo ancora da calcolare:",
    "estimatedUnpricedProduct": "{{product}} — Prezzo di listino: {{price}}",
    "estimatedUnpricedReasonProduct": "{{product}} — {{reasons}}",
    "estimatedQuantityPending": "Quantità in attesa",
    "estimatedCommercialBasisPending": "Unità d’acquisto in revisione commerciale",
    "estimatedUnitPending": "Unità in attesa",
    "estimatedUnpricedPriceReason": "Prezzo di listino: {{price}}",
    "estimatedPriceUnavailable": "Non disponibile",
    "estimatedPartial_one": "Resta da calcolare l’importo di {{count}} prodotto; il totale mostrato è parziale.",
    "estimatedPartial_other": "Resta da calcolare l’importo di {{count}} prodotti; il totale mostrato è parziale.",
    "continueDraft": "Continua",
    "dataSaved": "Dati del progetto aggiornati",
    "desiredDate": "Data desiderata",
    "detailDocuments": "Documenti",
    "detailTimeline": "Monitoraggio",
    "detailTitle": "Dettaglio della richiesta",
    "discardDraft": "Elimina",
    "discardDraftConfirm": "Elimina bozza",
    "discardDraftText": "«{{name}}» verrà eliminata insieme alle foto e alle righe aggiunte. L'operazione non è reversibile.",
    "discardDraftTitle": "Eliminare questa bozza?",
    "draftDiscarded": "Bozza eliminata.",
    "draftLabel": "Richiesta a metà",
    "draftSaved": "Bozza salvata",
    "draftText": "L’hai iniziata e non l’hai inviata.",
    "editData": "Modifica i dati",
    "editLine": "Modifica riga",
    "emptyText": "La tua prima distinta materiali comparirà qui dopo l'invio.",
    "emptyTitle": "Ancora nessuna richiesta",
    "excludeLine": "Rimuovi dall'elenco",
    "excluded": "Esclusa",
    "filesAdded": "File aggiunti",
    "filesReady_one": "{{count}} file pronto per l'elaborazione",
    "filesReady_other": "{{count}} file pronti per l'elaborazione",
    "goToRequests": "Vedi le mie richieste",
    "humanNoteText": "Questo elenco include i materiali che hai verificato e i suggerimenti che hai accettato.",
    "humanNoteTitle": "Atlas completerà anche la soluzione",
    "inProgressProcessing": "Lettura del tuo elenco",
    "inProgressSubmitted": "Preparazione del preventivo",
    "inProgressQuoteReview": "Un commerciale sta verificando il preventivo",
    "includeLine": "Includi nel preventivo",
    "itemsCount_one": "{{count}} articolo",
    "itemsCount_other": "{{count}} articoli",
    "leaveAndContinue": "Esci e continua più tardi",
    "leaveDraft": "Esci",
    "materialsNavigation": "Navigazione dei prodotti",
    "addMaterialsFirst": "Aggiungi almeno un prodotto o un file per continuare",
    "processWithAtlas": "Analizza con Atlas",
    "linesDetected_one": "{{count}} riga rilevata",
    "linesDetected_other": "{{count}} righe rilevate",
    "listSubtitle": "Controlla lo stato di tutto quello che hai inviato.",
    "listTitle": "Le mie richieste",
    "paginationSummary": "{{from}}–{{to}} di {{total}} richieste",
    "perPage": "Per pagina",
    "paginationAria": {
      "page": "Vai alla pagina {{page}}",
      "first": "Vai alla prima pagina",
      "last": "Vai all'ultima pagina",
      "next": "Vai alla pagina successiva",
      "previous": "Vai alla pagina precedente"
    },
    "location": "Luogo di installazione",
    "locationPlaceholder": "Città o indirizzo",
    "manualEntry": "Inserisci manualmente",
    "manualEntryHint": "Aggiungi i prodotti uno per uno",
    "manualHint": "Aggiungi i nostri prodotti o attiva Altri marchi per cercare equivalenze riga per riga.",
    "externalManufacturer": "Marchio est.",
    "otherBrands": "Altri marchi",
    "externalCode": "Codice/rif. esterno",
    "equivalence": {
      "resolved": "Equivale a {{product}} secondo Atlas.",
      "resolvedDetail": "{{source}} → {{product}}",
      "searching": "Ricerca equivalenze Atlas…",
      "noCandidates": "Nessun candidato certificato",
      "validated": "Convalidato",
      "proposal": "Proposta",
      "score": "Punteggio {{score}}/100",
      "notFound": "Atlas non dispone di un’equivalenza certificata.",
      "unavailable": "Impossibile consultare la mappa delle equivalenze."
    },
    "fromCatalog": "Dal catalogo",
    "fromCatalogHint": "I dati di un articolo del catalogo non si modificano qui. Per scriverlo a mano, cancella il codice.",
    "catalogSearching": "Ricerca nel catalogo…",
    "catalog": {
      "ambiguous": "Ci sono più articoli che corrispondono. Scegline uno dall’elenco.",
      "notFound": "Non è in catalogo. Puoi descriverlo a mano.",
      "unavailable": "Non siamo riusciti a consultare il catalogo. Compila la riga a mano."
    },
    "manualTitle": "Elenco manuale dei prodotti",
    "noCatalogResults": "Nessuna corrispondenza nel catalogo",
    "notes": "Note",
    "notesPlaceholder": "Aggiungi qualsiasi dettaglio da tenere presente…",
    "phaseFinishing": "Preparazione dell'elenco per la verifica",
    "phaseValidatingResult": "Convalida dell’elenco completo",
    "phaseIdentifying": "Individuazione di riferimenti e quantità",
    "phasePreparing": "Preparazione del documento",
    "phaseReading": "Riconoscimento del testo",
    "processingCompleted": "{{percent}} % completato",
    "processingErrorText": "Atlas non ha potuto completare l'analisi dei file. Puoi riprovare con i file salvati o aggiungerne altri.",
    "processingErrorTitle": "Non siamo riusciti a completare l'analisi",
    "returnToPreviousReview": "Torna all'elenco precedente",
    "processingRemaining": "Atlas sta ancora lavorando",
    "processingSavedText": "Non perderai i dati del progetto.",
    "processingSavedTitle": "La tua richiesta è stata salvata",
    "processingSubtitle": "L’avanzamento segue i dati di Atlas, con passaggi graduali tra le percentuali. In attesa di aggiornamenti resta visibile l’ultimo valore ricevuto.",
    "processingGuardTitle": "Atlas deve completare l’elenco",
    "processingGuardText": "La verifica si aprirà automaticamente quando Atlas avrà identificato e salvato un elenco valido.",
    "processingQualityTitle": "Atlas sta verificando la lettura",
    "processingQualityText": "La prima lettura non è abbastanza affidabile. Attendiamo un’interpretazione corretta senza mostrare dati errati.",
    "processingTitle": "Atlas sta analizzando il file",
    "queueGlobalLimit_one": "In coda · Capacità globale: {{count}} analisi simultanea. Non è un limite per cliente.",
    "queueGlobalLimit_other": "In coda · Capacità globale: {{count}} analisi simultanee. Non è un limite per cliente.",
    "queueUserLimit": "In coda: ogni utente può eseguire {{count}} analisi simultanee. Questa analisi inizierà automaticamente quando una delle tue termina.",
    "queueHighDemand": "La domanda è attualmente elevata. L’analisi è in coda e inizierà quando si libera capacità (limite globale: {{count}}).",
    "queuePosition": "Posizione in coda: {{position}}",
    "processingUpdateErrorTitle": "Impossibile aggiornare l’avanzamento",
    "processingUpdateErrorText": "Atlas sta ancora lavorando. Controlleremo di nuovo automaticamente.",
    "sendingPhotoTitle": "Invio della foto ad Atlas",
    "sendingPhotoSubtitle": "La scansione è terminata. L’immagine viene inviata in modo sicuro per avviare la lettura.",
    "photoModeTitle": "Foto dell’elenco",
    "photoModeHint": "Inquadra tutti i prodotti e assicurati che il testo sia chiaramente leggibile.",
    "photoPreviewAlt": "Foto dell’elenco dei prodotti",
    "openCamera": "Apri fotocamera",
    "scanningPhoto": "Atlas sta analizzando la foto",
    "projectData": "Dati del progetto",
    "projectDataHint": "Queste informazioni ti aiuteranno a ritrovare la richiesta in seguito.",
    "projectName": "Nome o riferimento del progetto",
    "projectNamePlaceholder": "Es. Ristrutturazione magazzino logistico Nord",
    "reactivateRequest": "Riattiva richiesta",
    "reanalyze": "Rianalizza",
    "reactivatedMessage": "Richiesta riattivata",
    "readingText": "Stiamo riconoscendo i codici e le quantità del documento che hai caricato. Potrai controllarlo appena finisce.",
    "readingTitle": "Atlas sta leggendo il tuo elenco",
    "removeRow": "Elimina riga",
    "requestOptions": "Opzioni della richiesta",
    "unidentifiedSummaryTitle": "Prodotti in sospeso",
    "unidentifiedSummaryCount": "{{count}} non identificati",
    "visualSummaryTitle": "Letture da confermare",
    "visualReadingSaved": "Lettura confermata",
    "visualIdentificationReady": "Letture confermate. Seleziona un prodotto in sospeso per rispondere alle domande di Atlas.",
    "visualPreparingQuestions": "Lettura salvata. Atlas sta preparando le domande per identificare i prodotti…",
    "visualSummaryCount": "{{count}} da confermare",
    "visualSummaryHint": "Conferma il testo e la quantità di ogni riga. Atlas mostrerà poi le domande per scegliere i prodotti.",
    "identifyProduct": "Identifica prodotto",
    "includedComponentLabel": "Accessori inclusi di serie",
    "atlasIncludedAccessory": "Incluso · Atlas",
    "atlasCandidateProducts": "Opzioni trovate da Atlas",
    "atlasCandidateProductsHint": "Atlas ha interpretato la necessità e convalidato queste opzioni nel catalogo. Scegli quella corretta.",
    "atlasGuidedSelectionTitle": "Atlas ti aiuta a scegliere",
    "atlasIdentityTitle": "Verifica l’identificazione",
    "atlasIdentityHint": "Atlas deve chiarire quale prodotto appare nell’immagine, non scegliere le sue caratteristiche.",
    "atlasIdentityField": "Codice o riferimento",
    "atlasIdentityQuestion": "Controlla il codice o il riferimento nell’immagine e correggilo se necessario. Puoi anche cercare il prodotto nel catalogo.",
    "atlasIdentityPlaceholder": "Inserisci il codice o il riferimento e, se la conosci, la marca",
    "atlasGuidedSelectionHint": "Seleziona le caratteristiche e mostreremo solo il prodotto compatibile.",
    "atlasReplacementTitle": "Alternative trovate da Atlas",
    "atlasReplacementHint": "Questo prodotto non è più disponibile. Atlas ha verificato queste opzioni come possibili sostituti.",
    "discontinuedProduct": "Prodotto fuori catalogo",
    "discontinuedCommercialReview": "Non esiste una sostituzione diretta confermata. Un commerciale esaminerà questa riga.",
    "discontinuedAlternativesAvailable": "Atlas ha trovato alternative compatibili. Verificale e seleziona quella adatta.",
    "currentProductRange": "gamma di prodotti attuale",
    "atlasRackWaiting": "Atlas sta calcolando lo spazio necessario e preparando i rack compatibili. Non devi selezionare nuovamente le apparecchiature.",
    "atlasRackSizingTitle": "Spazio calcolato da Atlas",
    "atlasRackEquipmentUnits": "Apparecchiature: {{count}} U",
    "atlasRackReserveUnits": "Riserva: {{count}} U",
    "atlasRackVentilationUnits": "Ventilazione: {{count}} U",
    "atlasRackMinimumUnits": "Minimo: {{count}} U",
    "atlasRackCompatibleSummary": "Sono mostrati {{count}} rack compatibili da {{units}} U o più",
    "atlasSelectionStep": "Passo {{step}}",
    "atlasPhoneLinesQuestion": "Quante linee telefoniche analogiche devi collegare all’ONT?",
    "atlasPhoneLinesHint": "Connessioni RJ11 per telefoni tradizionali.",
    "atlasPhoneLines_one": "1 linea telefonica",
    "atlasPhoneLines_other": "{{count}} linee telefoniche",
    "atlasNoPhoneLines": "Senza telefonia",
    "atlasAnswerPlaceholder": "Inserisci la risposta",
    "atlasAnaloguePhoneLines_one": "1 linea telefonica analogica",
    "atlasAnaloguePhoneLines_other": "{{count}} linee telefoniche analogiche",
    "atlasAnaloguePhoneConnections": "connessioni telefoniche analogiche",
    "atlasAnalogueTelephony": "telefonia analogica",
    "atlasChooseFormat": "Quale formato ti serve?",
    "atlasChooseUsers": "Quanti utenti deve supportare?",
    "atlasChoosePorts": "Quante porte ti servono?",
    "atlasChooseRackUnits": "Quale altezza ti serve?",
    "atlasChoosePots": "Quante porte telefoniche ti servono?",
    "atlasUsersUpTo": "Fino a {{count}} utenti",
    "atlasUsersRange": "Da {{from}} a {{to}} utenti",
    "atlasPorts": "{{count}} porte",
    "atlasRackUnits": "{{count}} U",
    "atlasPots": "{{count}} POTS",
    "atlasCompatibleProduct_one": "Prodotto compatibile",
    "atlasCompatibleProduct_other": "Prodotti compatibili",
    "atlasProductCode": "Codice {{code}}",
    "atlasSelectProduct": "Scegli",
    "atlasProductSelected": "Selezionato",
    "atlasSearchOtherProduct": "Cerca un altro prodotto nel catalogo",
    "atlasHideCatalogSearch": "Nascondi la ricerca nel catalogo",
    "atlasQuestionsTitle": "Informazione necessaria per scegliere correttamente",
    "recognitionRecommendationsTitle": "Consigliato da Atlas",
    "recognitionRecommendationsHint": "Complementi che Atlas considera necessari. Potrai decidere nel passaggio successivo.",
    "validateEquivalence": "Convalida equivalenza",
    "equivalenceValidated": "Equivalenza convalidata",
    "pendingProductsFooter": "Restano {{count}} prodotti da identificare",
    "pendingSuggestionsFooter_one": "Resta 1 prodotto suggerito da Atlas da confermare",
    "pendingSuggestionsFooter_other": "Restano {{count}} prodotti suggeriti da Atlas da confermare",
    "pendingEquivalencesFooter": "Restano {{count}} equivalenze da convalidare",
    "commercialReviewFooter_one": "1 prodotto passerà alla revisione commerciale",
    "commercialReviewFooter_other": "{{count}} prodotti passeranno alla revisione commerciale",
    "reviewReadyFooter": "Revisione completata",
    "reviewNavigation": "Navigazione della revisione",
    "reviewList": "Elenco",
    "reviewSubtitle": "Verifica ogni riga prima di richiedere il preventivo.",
    "visualReviewTitle": "Conferma la lettura dell’immagine",
    "visualReviewConfirm": "Conferma lettura",
    "visualEditReading": "Modifica lettura",
    "visualReviewConfirming": "Conferma…",
    "visualLiteralDescription": "Testo letto nell’immagine",
    "visualReviewUncertainties": "Dati da verificare",
    "visualTextOptions": "Letture proposte da Atlas",
    "visualQuantityOptions": "Quantità proposte da Atlas",
    "visualUnitOptions": "Unità proposte da Atlas",
    "visualQuantityAlternatives": "Quantità possibili: {{values}}",
    "visualUncertainTokens": "Testo incerto: {{values}}",
    "visualAlternativeReadings": "Altre letture possibili: {{values}}",
    "visualReviewReasonGeneric": "Atlas ha rilevato differenze tra diverse letture di questa riga.",
    "visualReviewLineHint": "Conferma o correggi prima la lettura. Atlas cercherà poi le opzioni compatibili.",
    "atlasMoreQuestionsNeeded": "Atlas ha bisogno di maggiori dettagli prima di mostrare i prodotti compatibili.",
    "saveDraft": "Salva la bozza",
    "searchCatalog": "Cerca nel catalogo",
    "changeProduct": "Cambia prodotto",
    "changeProductHint": "Cerca per codice o riferimento e scegli il prodotto. Cambia solo l'articolo: la quantità o l'unità in sospeso si conferma comunque qui.",
    "saveProduct": "Salva prodotto",
    "searchCatalogHint": "Scrivi un codice, un riferimento o parte della descrizione e scegli il prodotto: i campi si compilano da soli.",
    "searchPlaceholder": "Cerca per riferimento o progetto",
    "secureText": "Saranno usati solo per preparare e gestire il tuo preventivo.",
    "secureTitle": "I tuoi dati sono al sicuro",
    "sendDialogText": "Dopo l'invio non potrai più modificare l'elenco. Ti avviseremo appena il preventivo sarà pronto.",
    "sendDialogTitle": "Inviare la richiesta ad Atlas?",
    "sendRequest": "Invia la richiesta",
    "sentEyebrow": "RICHIESTA INVIATA",
    "sentOn": "Inviata il {{date}}",
    "sentRef": "Riferimento della richiesta",
    "sentRedirect": "Apertura automatica del dettaglio tra {{seconds}} s.",
    "sentRedirectLabel": "secondi all’apertura automatica del dettaglio",
    "sentCountdown": "Il monitoraggio Atlas apparirà tra {{seconds}} s.",
    "sentCountdownLabel": "Secondi prima del monitoraggio Atlas",
    "sentText": "Atlas sta preparando il preventivo. Ti avviseremo appena sarà disponibile.",
    "sentTitle": "Abbiamo ricevuto la tua richiesta",
    "startProcessing": "Avvia l'elaborazione",
    "stepConfirm": "Conferma",
    "stepValuation": "Valorizzazione",
    "stepData": "Dati",
    "stepDocuments": "Documenti",
    "stepOf": "Passo {{current}} di {{total}}",
    "stepProcessing": "Elaborazione",
    "stepReview": "Verifica",
    "stepRecommendations": "Suggerimenti",
    "recommendationsTitle": "Completa la soluzione",
    "recommendationsSubtitle": "Atlas ha esaminato l’insieme per trovare prodotti, licenze o servizi mancanti.",
    "recommendationsAnalyzing": "Atlas sta verificando la soluzione",
    "recommendationsAnalyzingHint": "Controlla compatibilità, capacità ed elementi inclusi per evitare duplicati.",
    "recommendationsFailed": "Atlas non ha potuto completare i suggerimenti.",
    "recommendationsNeedInfo": "Atlas necessita di un’informazione",
    "recommendationsNeedInfoHint": "Le risposte permettono di scegliere la variante e la quantità corrette.",
    "analyzeAnswers": "Analizza risposte",
    "analyze": "Analizza",
    "imagesReady_one": "1 immagine pronta per l’analisi",
    "imagesReady_other": "{{count}} immagini pronte per l’analisi",
    "imagesAdded": "Immagini aggiunte",
    "addPhoto": "Aggiungi foto",
    "recommendationsFound_one": "1 suggerimento Atlas",
    "recommendationsFound_other": "{{count}} suggerimenti Atlas",
    "recommendationPending": "Da confermare",
    "recommendationImportance": {
      "required": "Necessario",
      "recommended": "Consigliato",
      "optional": "Opzionale"
    },
    "recommendationCategory": {
      "prerequisite": "Requisito tecnico",
      "license": "Licenza",
      "compatibility": "Compatibilità",
      "accessory": "Accessorio",
      "service": "Servizio"
    },
    "recommendedQuantity": "Quantità suggerita: {{quantity}} {{unit}}",
    "addRecommendation": "Aggiungi",
    "replaceRecommendation": "Sostituisci",
    "discardRecommendation": "Scarta",
    "recommendationAdded": "Aggiunto",
    "recommendationReplaced": "Sostituito",
    "replacementOf": "Sostituisce {{products}}",
    "addedByAtlas": "Aggiunto su suggerimento di Atlas",
    "replacedByAtlas": "Sostituito su suggerimento di Atlas",
    "siteNumber": "Installazione {{count}}",
    "recommendationDiscarded": "Scartato",
    "notKnownYet": "Non lo so ancora",
    "noRecommendations": "La soluzione è completa",
    "noRecommendationsHint": "Atlas non ha rilevato altri prodotti da esaminare.",
    "recommendationsQuestionsFooter": "Mancano {{count}} risposte",
    "recommendationsPendingFooter": "Restano {{count}} suggerimenti da esaminare",
    "recommendationsReadyFooter": "Suggerimenti esaminati",
    "takeAnotherPhoto": "Scatta un'altra foto",
    "takePhoto": "Scatta una foto",
    "takePhotoHint": "Usa la fotocamera del dispositivo",
    "titleData": "Parlaci del progetto",
    "titleMaterials": "Documenti del progetto",
    "uploadFile": "Carica un file o un foglio di calcolo",
    "uploadFileHint": "PDF, Word, immagine, XLSX, XLS o CSV · Word viene convertito in PDF",
    "dragFilesHint": "Puoi anche trascinare qui uno o più file per allegarli.",
    "dropFilesHere": "Rilascia i file per allegarli",
    "viewBudget": "Vedi il preventivo",
    "recognisedSoFar": "Riconosciuti: {{count}}",
    "matchEquivalentFrom": "Chiedevi {{marca}}; ti proponiamo questo equivalente EK",
    "match": {
      "direct": "Letto così com’è",
      "equivalent": "Equivalente EK",
      "none": "Non identificato",
      "not_needed": "Non serve",
      "noEquivalent": "Nessun equivalente EK",
      "noEquivalentLong": "Identificato come {{marca}}, ma non abbiamo un equivalente EK"
    },
    "showDiscardedRows": "Mostra {{count}} righe messe da parte",
    "hideDiscardedRows": "Nascondi le righe messe da parte",
    "discarded": {
      "headerRow": "Intestazione della tabella",
      "documentTitle": "Titolo del documento",
      "partidaRow": "Voce duplicata dalla relativa suddivisione",
      "outsideNumberedTable": "Contenuto fuori dalla tabella dei materiali",
      "unreadableText": "Testo illeggibile",
      "otherScope": "Altra voce (manodopera, servizio o opere civili)",
      "otherBrand": "Prodotto non Ek/Openetics",
      "otherBrandMaker": "Altra marca ({{brands}})",
      "otherBrandFamily": "Fuori dal catalogo Ek/Openetics ({{family}})",
      "documentText": "Testo del documento (condizioni, note)"
    },
    "colProduct": "Prodotto",
    "colReference": "Riferimento",
    "colDescription": "Descrizione",
    "documentTechnicalWarning": "Avviso: {{differences}}. Il prodotto identificato viene mantenuto.",
    "documentTechnicalDifference": "il documento indica «{{source}}» e il catalogo «{{catalog}}»",
    "colBrand": "Marca di origine",
    "colQuantity": "Quantità",
    "colUnitPrice": "Prezzo",
    "colDiscount": "Sconto",
    "colLineSubtotal": "Subtotale",
    "colStatus": "Stato",
    "convertedToEk": "Convertito in EK",
    "groupResolved": "{{resolved}} prodotti riconosciuti su {{count}}",
    "groupExcluded": "{{count}} esclusi",
    "groupsDetected": "{{count}} voci rilevate",
    "previewSelectCatalogProduct": "Seleziona un prodotto dai risultati del catalogo per modificare il codice o il riferimento.",
    "atlasSuggestion": "Suggerito da Atlas",
    "atlasSuggestionHint": "Alternativa proposta da Atlas.",
    "reanalyzeDialogTitle": "Analizzare di nuovo la richiesta?",
    "reanalyzeDialogText": "Atlas rileggerà i documenti con la versione attuale. Il nuovo elenco sostituirà quello attuale e le modifiche fatte durante la revisione andranno perse.",
    "documentReading": {
      "pending": "Lettura del documento in attesa di revisione",
      "title": "Conferma o correggi la lettura",
      "help": "Scegli un'azione per ogni riga o avviso. Una quantità vuota resterà in sospeso; confermare il testo non identifica il prodotto.",
      "fragment": "Frammento in sospeso",
      "action": "Azione di revisione",
      "material": "Conferma o correggi il materiale",
      "ignore": "Scarta la riga / prendi atto dell'avviso",
      "text": "Testo letto",
      "quantity": "Quantità (vuota se sconosciuta)",
      "unit": "Unità del documento",
      "close": "Chiudi",
      "save": "Salva revisione"
    },
    "queueNoUserLimit": "In coda per l'esecuzione. Il tuo utente non ha un limite di analisi simultanee.",
    "recommendationsNavigation": "Navigazione dei suggerimenti",
    "includedComponentReason": "aggiunti automaticamente con il rack {{rack}}, senza costi.",
    "includedComponentReasonGeneric": "aggiunti automaticamente con il rack, senza costi.",
    "atlasSuggestionLabel": "Alternativa di Atlas",
    "atlasSuggestionOtherBrand": "Alternativa {{brand}} (altra marca)",
    "atlasSuggestionDifferences_one": "{{count}} differenza",
    "atlasSuggestionDifferences_other": "{{count}} differenze",
    "showDifferences": "Mostra differenze",
    "hideDifferences": "Nascondi differenze",
    "notInCatalogShort": "Nessun equivalente nel catalogo",
    "originalBrandCaption": "Nel documento: {{value}}",
    "atlasRackNotCounted": "Non classificati da Atlas per il rack, quindi non conteggiati: {{items}}",
    "atlasRackUnresolved": "Altezza in U sconosciuta, non conteggiata: {{items}}. Il minimo conta solo le apparecchiature con altezza nota.",
    "atlasRackExcluded": "Non occupano il rack: {{items}}",
    "atlasRackWaitingUnits": "Atlas non conosce ancora l’altezza in U di alcune apparecchiature dell’elenco e non può calcolare lo spazio del rack.",
    "atlasRackWaitingUnitsNamed": "Atlas non può calcolare lo spazio del rack: non ha un’altezza in U verificata per {{items}}.",
    "atlasRackSizingTitleCurrent": "Spazio con l’elenco attuale",
    "atlasRackStale": "L’elenco è cambiato dopo il calcolo di Atlas (minimo {{minimum}} U): lo spazio è stato ricalcolato con le righe attuali e le altezze pubblicate da Atlas.",
    "atlasRackStaleNoRecompute": "L’elenco è cambiato dopo il calcolo di Atlas e questi valori potrebbero non essere aggiornati: verifica lo spazio prima di scegliere il rack.",
    "atlasRackNotEvaluated": "Atlas non ha valutato queste righe per il rack (aggiunte o modificate nell’elenco), quindi non sono conteggiate: {{items}}",
    "atlasRackPassive": "Elementi passivi del rack, non conteggiati dal calcolo: {{items}}",
    "atlasRackRecommendedNotInList": "Atlas conteggiava anche apparecchiature consigliate che non sono nell’elenco: {{items}}",
    "atlasRackStaleSummary": "Con l’elenco attuale serve un rack da {{units}} U o più.",
    "atlasRackStaleSummaryMinimum": "Con l’elenco attuale il minimo è di {{units}} U.",
    "atlasRackCandidateTooSmall": "Ha meno spazio del minimo attuale ({{units}} U).",
    "showAtlasNote": "Mostra dettagli",
    "hideAtlasNote": "Nascondi dettagli",
    "showFullNote": "Mostra la nota completa",
    "showLessNote": "Riduci la nota",
    "includesStandardAccessories": "Include {{items}} di serie, senza costi: viene aggiunto all’elenco automaticamente.",
    "rackCandidateIncludes": "Scegliendo questo rack si aggiunge {{items}} all’elenco: è di serie, senza costi.",
    "pdfProcessing": {
      "label": "Analisi dei documenti con Atlas",
      "document": "Documento",
      "reading": "Lettura",
      "catalog": "Catalogo",
      "upload": "Preparazione del documento",
      "read": "Lettura del documento",
      "map": "Ricerca nel catalogo",
      "done": "Lettura completata",
      "waiting": "In attesa di Atlas",
      "lines": "Righe rilevate",
      "matched": "Prodotti trovati",
      "files_one": "{{count}} file",
      "files_other": "{{count}} file",
      "sheet": "Foglio 1",
      "products": "Prodotti",
      "portal": "Portale clienti",
      "received": "Ricezione dei dati",
      "following": "Monitoraggio dell’analisi",
      "sending": "Documenti → Atlas",
      "returning": "Atlas → Portale",
      "exchange": {
        "prepare": "Preparazione dei documenti",
        "send": "Atlas sta leggendo i documenti",
        "reason": "Atlas sta elaborando l’elenco",
        "match": "Atlas sta assegnando i riferimenti",
        "receive": "Ricezione del risultato nel portale",
        "waiting": "In attesa di Atlas",
        "checking": "Atlas sta verificando il risultato"
      },
      "atlas": {
        "prepare": "Ricezione dei documenti",
        "send": "Lettura dell’elenco",
        "reason": "Elaborazione dell’elenco",
        "match": "Assegnazione riferimenti",
        "receive": "Elenco pronto",
        "waiting": "In attesa",
        "checking": "Verifica del risultato"
      }
    },
    "copyReference": "Copia riferimento della richiesta",
    "copyReferenceFailed": "Impossibile copiare il riferimento.",
    "validateAllAndContinue": "Convalida tutto e continua",
    "validatingAll": "Convalida…",
    "partidaOutsideCatalogTitle": "Prodotti non Ek/Openetics",
    "partidaOutsideCatalogHint_one": "{{count}} prodotto del progetto non è a catalogo. Atlas propone un’alternativa equivalente quando esiste.",
    "partidaOutsideCatalogHint_other": "{{count}} prodotti del progetto non sono a catalogo. Atlas propone un’alternativa equivalente quando esiste.",
    "partidaUntitled": "Voce senza titolo",
    "partidaMeasure": "Misura {{measure}}",
    "partidaProducts_one": "{{count}} prodotto",
    "partidaProducts_other": "{{count}} prodotti",
    "atlasScene": {
      "label": "Analisi di Atlas",
      "document": "Documento",
      "waiting": "In attesa di Atlas",
      "phase": {
        "upload": "Preparazione dei tuoi documenti",
        "extract": "Atlas sta separando ogni riga del documento",
        "enter": "Le righe entrano in Atlas",
        "master": "Atlas sta cercando ogni riga nel Master",
        "compose": "Atlas sta componendo l’elenco",
        "ready": "Elenco pronto",
        "handoff": "Apertura del tuo elenco"
      },
      "atlas": {
        "upload": "in attesa",
        "extract": "lettura",
        "enter": "ricezione",
        "master": "consultazione del Master",
        "compose": "composizione",
        "ready": "pronto",
        "handoff": "pronto"
      },
      "master": {
        "searching": "Consultazione del Master",
        "done": "Composizione dell’elenco",
        "badge": "Master",
        "review": "Verifica in corso…"
      },
      "list": {
        "title": "Elenco",
        "ready": "Il tuo elenco",
        "chip": "Pronto"
      },
      "steps": {
        "upload": "Caricamento",
        "extract": "Estrazione",
        "enter": "Invio ad Atlas",
        "master": "Master",
        "compose": "Elenco",
        "portal": "Portale"
      },
      "voice": {
        "upload": "Ricevo il tuo documento",
        "extract": "Leggo ogni riga",
        "enter": "Sto pensando",
        "master": "Cerco nel Master",
        "compose": "Compongo il tuo elenco",
        "ready": "Pronto",
        "handoff": "Pronto",
        "waiting": "Aspetto il mio turno"
      }
    }
  },
  "requestStatus": {
    "in_progress": "In corso",
    "quote_rejected": "Rifiutata in revisione commerciale",
    "submission_blocked": "Invio bloccato",
    "draft": "Bozza",
    "processing": "Lettura dell’elenco",
    "review": "In attesa di verifica",
    "submitted": "Preventivo in preparazione",
    "quote_review": "Preventivo in revisione",
    "quote_validated": "Preventivo convalidato · in attesa di accettazione",
    "quote_partially_validated": "Preventivo parzialmente convalidato · in attesa di revisione",
    "quote_won": "Preventivo vinto",
    "quote_lost": "Preventivo perso",
    "quoted": "Preventivo disponibile",
    "cancelled": "Annullata",
    "failed": "Errore di lettura",
    "ordering": "Conversione in ordine",
    "ordered": "Ordine creato",
    "order_blocked": "Ordine non confermato"
  },
  "support": {
    "title": "Supporto",
    "subtitle": "Raccontaci di cosa hai bisogno e ti risponderemo via e-mail.",
    "topic": "Oggetto",
    "topicRequest": "Domanda su una richiesta",
    "topicBudget": "Domanda su un preventivo",
    "topicAccount": "Problema con il mio account",
    "topicOther": "Altro argomento",
    "relatedRef": "Riferimento collegato",
    "message": "Messaggio",
    "messagePlaceholder": "Descrivi la tua domanda nel modo più dettagliato possibile…",
    "send": "Invia la richiesta",
    "sentTitle": "Abbiamo ricevuto il tuo messaggio",
    "sentText": "Risponderemo all'e-mail del tuo account entro 24 ore lavorative.",
    "received": "Messaggio inviato"
  },
  "theme": {
    "label": "Tema",
    "light": "Chiaro",
    "dark": "Scuro",
    "system": "Come il sistema"
  },
  "unitReview": {
    "processing": "Atlas sta confermando l’unità…",
    "pending": "Unità da confermare",
    "line": "Componente",
    "sourceGroup": "Voce di origine",
    "confirm": "Conferma unità",
    "change": "Correggi unità",
    "title": "Conferma unità di misura",
    "original": "Unità originale: {{unit}}",
    "source": "Pagina/foglio {{page}} · riga {{row}} · codice {{code}}",
    "quantityUnchanged": "Si conferma solo l’unità di questa riga. Quantità, altre righe e gruppo originale restano invariati.",
    "choose": "Scegli un’unità ammessa",
    "separateAction": "Conferma o correggi l’unità con l’azione dedicata della riga; scegliere un prodotto non la conferma.",
    "blocked": "Conferma le unità in sospeso delle righe materiale prima di continuare.",
    "returnToReview": "Verifica unità",
    "orderBlocked": "L’ordine non può essere accettato finché ci sono unità da confermare. Verifica la richiesta collegata.",
    "notSynchronized": "L’unità non è stata applicata: Atlas non ha confermato la modifica e la riga è ancora da confermare. Confermala di nuovo."
  },
  "units": {
    "ud": "pz",
    "m": "m",
    "kg": "kg",
    "h": "h",
    "box": "scatola"
  },
  "atlasPending": {
    "title": "In attesa di Atlas",
    "help": "Seleziona un prodotto per rispondere ad Atlas e completarne l'identificazione.",
    "fullDescription": "Descrizione completa"
  },
  "installation": {
    "comingSoon": "Prossimamente",
    "describeTitle": "Descrivi il tuo impianto ad Atlas",
    "describeHint": "Atlas prepara i materiali in base a ciò che ti serve",
    "steps": {
      "description": "Il tuo impianto",
      "details": "Dettagli",
      "materials": "Materiali",
      "suggestions": "Suggerimenti",
      "technicalReview": "Revisione tecnica",
      "confirmation": "Conferma"
    },
    "phases": {
      "revision": "Revisione dei materiali",
      "confirmar": "Conferma del preventivo"
    },
    "newRequestNotice": "Questa richiesta contiene già materiali o documenti. Inviando la descrizione creeremo un'altra richiesta con gli stessi dati del progetto e conserveremo questa.",
    "restartNotice": "Se invii di nuovo la descrizione, Atlas avvierà una nuova analisi e ti chiederà di nuovo i dettagli necessari.",
    "tellUs": "Raccontaci di cosa hai bisogno",
    "descriptionLabel": "Il tuo impianto",
    "descriptionHelp": "Descrivi l'obiettivo, le dimensioni, le apparecchiature esistenti e qualsiasi requisito di cui dobbiamo tenere conto.",
    "useExample": "Usa una descrizione di esempio",
    "example": "Voglio migliorare il Wi-Fi di un ufficio su un solo piano con quattro stanze. Ho già il router e il cablaggio di rete. Mi servono access point per circa venti utenti e voglio sapere quali altre apparecchiature sono necessarie.",
    "proposalTitle": "La tua proposta di materiali",
    "technicalPendingTitle": "In attesa di verifiche tecniche",
    "atlasUpdatePendingTitle": "In attesa di un aggiornamento di Atlas",
    "resolveHint": "Non devi rispondere di nuovo. Atlas deve completare la selezione con la documentazione e le alternative disponibili.",
    "noMoreQuestions": "Atlas non ha altre domande per te al momento. La tua richiesta è salvata e puoi riprenderla dalla Home.",
    "previewNotice_one": "Il materiale è un'anteprima. Potrai confermarlo, modificarlo o rimuoverlo quando Atlas avrà terminato le verifiche.",
    "previewNotice_other": "I {{count}} materiali sono un'anteprima. Potrai confermare, modificare o rimuovere ciascuno quando Atlas avrà terminato le verifiche.",
    "correctDescription": "Correggi la descrizione",
    "blockersNotice": "Prima di mostrare una proposta pronta da confermare restano queste verifiche.",
    "atlasDetails": "Vedi i dettagli di Atlas",
    "noProposalYet": "Non c'è ancora una proposta disponibile. Controlla lo stato per vedere se ci sono novità.",
    "clarifyTitle": "Chiariamo il tuo impianto",
    "clarifyHint": "Tocca ogni argomento per rispondere passo dopo passo. Poi invieremo le tue risposte ad Atlas.",
    "retryableFailure": "Atlas non è riuscito a terminare l'analisi per un'interruzione temporanea. Le tue risposte sono salvate. Puoi riprovare senza ricominciare.",
    "failure": "Atlas non è riuscito a completare la proposta. Puoi rivedere la descrizione e riprovare.",
    "plannerUnavailableTitle": "Atlas non è riuscito a pianificare l’impianto in questo momento",
    "plannerUnavailableText": "La tua descrizione è stata conservata. Puoi riprovare tra qualche minuto o compilare tu l’elenco dei prodotti; Atlas li identificherà nel catalogo quando continui.",
    "plannerRetry": "Riprova",
    "awaitingConfirmation": "In attesa della tua conferma",
    "whyComponents": "Perché questi componenti",
    "youDecideTitle": "Decidi tu cosa entra nel preventivo",
    "youDecideText": "Prima risolveremo i dettagli mancanti. Poi potrai rivedere i materiali, capire perché sono stati scelti e aggiungere miglioramenti facoltativi.",
    "yourDescription": "La tua descrizione",
    "atlasObservations": "Osservazioni di Atlas",
    "referenceFiles": "File di riferimento",
    "optionalTag": "(facoltativo)",
    "confirmedCount": "{{confirmed}} di {{total}} materiali confermati.",
    "provisionalCount_one": "1 materiale provvisorio · In attesa di Atlas",
    "provisionalCount_other": "{{count}} materiali provvisori · In attesa di Atlas",
    "detailsCompleted": "{{done}} di {{total}} dettagli completati",
    "retrying": "Nuovo tentativo di analisi…",
    "resolving": "Revisione con Atlas…",
    "checking": "Verifica in corso…",
    "preparingAction": "Preparazione della proposta…",
    "retry": "Riprova l'analisi",
    "resolve": "Risolvi con Atlas",
    "checkStatus": "Controlla lo stato",
    "sendDescription": "Invia proposta",
    "reviewDescription": "Rivedi la descrizione",
    "sendAnswers": "Invia risposte",
    "reviewTopic": "Rivedi: {{topic}}",
    "clarifyTopic": "Chiarisci: {{topic}}",
    "answersSaved": "Risposte salvate. Puoi rivederle.",
    "stepsToClarify_one": "1 passo per chiarirlo",
    "stepsToClarify_other": "{{count}} passi per chiarirlo",
    "tapToAnswer": "Tocca per rispondere",
    "completed": "Completato",
    "pending": "In sospeso",
    "clarifyDetail": "Chiarisci questo dettaglio",
    "closeKeepAnswers": "Chiudi e conserva le risposte",
    "previous": "Indietro",
    "backToQuestions": "Torna alle domande",
    "next": "Avanti",
    "saveAnswers": "Salva le risposte",
    "selectOption": "Seleziona un'opzione",
    "quantity": "Quantità",
    "yourAnswer": "La tua risposta",
    "optionalAnswer": "Facoltativo. Puoi continuare senza rispondere.",
    "whyAtlasAsks": "Perché Atlas lo chiede?",
    "preparingTitle": "Atlas sta preparando il tuo impianto",
    "preparingText": "Stiamo esaminando la tua descrizione e i prodotti del catalogo.",
    "preparingProgress": "Atlas sta preparando la proposta",
    "preparingLeave": "Puoi uscire e tornare a questa richiesta per continuare.",
    "columns": {
      "code": "Codice",
      "reference": "Riferimento",
      "name": "Descrizione breve",
      "quantity": "Quantità",
      "actions": "Azioni"
    },
    "proposalTableLabel": "Materiali proposti da Atlas",
    "allRemoved": "Hai rimosso tutti i materiali. Torna alla descrizione per preparare un'altra proposta.",
    "confirmItem": "Conferma {{name}}",
    "editItem": "Modifica {{name}}",
    "itemConfirmed": "{{name}} confermato",
    "remove": "Rimuovi",
    "removeItem": "Rimuovi {{name}}",
    "userCatalogReason": "Prodotto selezionato da te nel catalogo. La sua idoneità all'impianto è in attesa di revisione.",
    "referencesHint": "Aggiungi planimetrie, foto o documenti per aiutare Atlas a capire l'impianto.",
    "removeFile": "Rimuovi file",
    "savingReferences": "Salvataggio dei file di riferimento",
    "referencesLocked": "Per cambiare questi file, riavvia l'analisi della proposta.",
    "changeFiles": "Cambia file",
    "savingFiles": "Salvataggio dei file…",
    "attachFiles": "Allega file",
    "attachReferences": "Allega file di riferimento",
    "referencesLimits": "PDF, JPG, PNG o WebP. Fino a 5 file, 10 MB per file e 20 MB in totale.",
    "changeReferencesTitle": "Cambia i file di riferimento",
    "changeReferencesText": "La descrizione e i file verranno conservati. Dopo averli cambiati dovrai inviare di nuovo la proposta; Atlas la analizzerà di nuovo e le risposte dell'analisi precedente non verranno utilizzate.",
    "verificationTitle": "Revisione tecnica di Atlas",
    "verified": "Atlas ha verificato questo elenco. Ora puoi rivedere il riepilogo e confermare la richiesta.",
    "verifying": "Atlas sta verificando i prodotti, le quantità e la loro compatibilità…",
    "verificationQuestions": "Atlas ha bisogno di questi dettagli per convalidare il tuo impianto",
    "verificationBlocked": "La revisione non consente ancora di confermare. Controlla le osservazioni di Atlas e correggi l'elenco o completa i dettagli.",
    "verificationIntro": "Prima della conferma, Atlas verificherà l'impianto con l'elenco che hai rivisto e i miglioramenti selezionati.",
    "reviewMaterials": "Rivedi i materiali",
    "listVerified": "Elenco verificato",
    "verificationRunning": "Revisione in corso",
    "verificationPending": "In attesa di revisione",
    "verifyWithAtlas": "Verifica con Atlas",
    "suggestionsTitle": "Completa il tuo impianto",
    "suggestionsHint": "Rivedi i suggerimenti di Atlas e decidi quali aggiungere alla tua proposta.",
    "backToProposal": "Torna alla proposta",
    "observations": {
      "analysisNeedsInput": "Completa i dettagli di cui Atlas ha bisogno per verificare l'impianto.",
      "lineRevision": "Rivedi i materiali: Atlas ha rilevato componenti necessari o incompatibilità ancora da risolvere.",
      "mandatoryDependencies": "Mancano componenti necessari al funzionamento dell'impianto. Rivedi i suggerimenti di Atlas.",
      "catalogChanged": "Il catalogo è cambiato. Rivedi i prodotti prima di convalidare di nuovo l'impianto.",
      "catalogMismatch": "Atlas deve correggere i riferimenti o le unità che non corrispondono al catalogo prima di mostrare i materiali.",
      "pending": "C'è una verifica di Atlas in sospeso.",
      "reviewNeeded": "Atlas ha bisogno che tu riveda l'impianto prima di continuare."
    },
    "plannerReadAsList": "Fallo leggere ad Atlas come elenco",
    "typedTextPlannerNotice": "Atlas ha letto il tuo testo e descrive un impianto, non un elenco di prodotti: prepara la proposta di impianto a partire da questa stessa descrizione.",
    "materialListBlockedTitle": "Non siamo riusciti a leggere l’elenco in questa richiesta",
    "materialListBlockedText": "Il tuo elenco è stato conservato. Questa richiesta è cambiata mentre lo scrivevi e ora non può riceverlo. Puoi far leggere l’elenco ad Atlas in una nuova richiesta con gli stessi dati del progetto oppure inserire i prodotti a mano.",
    "materialListNewRequest": "Leggilo in una nuova richiesta"
  },
  "adaltra": {
    "portal": "Portale clienti",
    "workspace": "Il tuo spazio di lavoro",
    "helpTitle": "Siamo qui per aiutarti",
    "helpBody": "Ti aiutiamo con le richieste e i preventivi.",
    "helpAction": "Contatta il supporto",
    "skip": "Vai al contenuto",
    "openMenu": "Apri menu",
    "closeMenu": "Chiudi menu",
    "navigation": "Navigazione principale",
    "activity": "Il tuo portale",
    "account": "Il tuo account",
    "search": "Cerca richieste",
    "searchHint": "Cerca richieste per nome o riferimento…",
    "noResults": "Nessuna sezione trovata",
    "welcome": "Benvenuto nel tuo portale",
    "client": "Cliente",
    "team": "Team ADALTRA",
    "navigate": "Cerca una sezione",
    "navigateHint": "Vai a una sezione…",
    "searchSubmit": "Cerca richieste",
    "expandSidebar": "Espandi menu",
    "collapseSidebar": "Comprimi menu"
  },
  "pdfLab": {
    "nav": "Lettura PDF",
    "title": "Leggi il documento prima di inviarlo",
    "eyebrow": "Documenti / Atlas",
    "subtitle": "Estrai il testo, verifica i prodotti e prepara solo i dati necessari ad Atlas.",
    "drop": "Trascina qui i documenti",
    "formats": "PDF, JPG e PNG · Fino a 15 MB per file e 60 pagine totali",
    "select": "Seleziona documenti",
    "forceOcr": "Forza OCR su tutte le pagine",
    "readAgain": "Leggi di nuovo",
    "progressOcr": "Riconoscimento OCR della pagina {{page}}…",
    "progressText": "Estrazione del testo della pagina {{page}}…",
    "tooLarge": "Il file è vuoto o supera 15 MB.",
    "tooManyPages": "I documenti superano 60 pagine. Dividi il file.",
    "tooManyPixels": "La pagina è troppo grande per il browser.",
    "unsupported": "Seleziona un PDF, JPG o PNG valido.",
    "unreadable": "Impossibile leggere il documento. Verifica che sia integro e non protetto da password.",
    "pageCount": "{{count}} pagine",
    "lineCount": "{{count}} prodotti letti",
    "ocrCount": "{{count}} pagine con OCR",
    "reviewHint": "Verifica riferimenti, descrizioni, quantità e unità. L’originale rimane sul dispositivo. Nessun PDF viene inviato ad Atlas.",
    "products": "Prodotti del documento",
    "identify": "Verifica nel catalogo",
    "identifying": "Consultazione del catalogo…",
    "include": "Includi",
    "reference": "Riferimento",
    "description": "Descrizione",
    "quantity": "Quantità",
    "unit": "Unità",
    "brand": "Marca",
    "status": "Identificazione",
    "exact": "Corrispondenza esatta",
    "approximate": "Candidati da verificare",
    "unmatched": "Nessuna corrispondenza",
    "unavailable": "Catalogo non disponibile",
    "pending": "Non verificato",
    "pages": "Testo originale per pagina",
    "page": "Pagina {{page}}",
    "embedded": "Testo del PDF",
    "sourceText": "Testo originale",
    "onlyLines": "Prepara solo le righe prodotto selezionate",
    "preparedText": "Testo da inviare ad Atlas",
    "textCount": "{{count}} caratteri · Il contenuto non viene mai troncato automaticamente.",
    "download": "Scarica testo",
    "send": "Invia il testo verificato ad Atlas",
    "sending": "Invio del testo…",
    "textUnsupported": "Questa connessione Atlas non supporta ancora il testo. Puoi scaricarlo. Il PDF non verrà inviato in alternativa.",
    "textTooLong": "Il testo supera i limiti di questa connessione Atlas. Rivedi la selezione o prepara richieste separate.",
    "sendError": "Impossibile inviare il testo. Verifica lo stato della richiesta prima di riprovare.",
    "newDraftRequired": "Per la lettura PDF, apri una nuova richiesta senza documenti o prodotti. La richiesta attuale viene conservata.",
    "pageCount_one": "1 pagina",
    "lineCount_one": "1 prodotto letto",
    "ocrCount_one": "1 pagina con OCR",
    "editLine": "Correggi prodotto letto",
    "reviewTitle": "Verifica i prodotti letti",
    "reviewSubtitle": "Verifica quantità e riferimenti. Correggi ogni prodotto prima di continuare.",
    "uploadTitle": "Aggiungi documenti",
    "uploadSubtitle": "Leggeremo testo e pagine scansionate prima di inviarli ad Atlas.",
    "changeMethod": "Cambia metodo",
    "textCountShort": "{{count}} caratteri"
  },
  "preferences": {
    "title": "Preferenze",
    "subtitle": "Scegli quali avvisi ricevere e tramite quale canale.",
    "notifications": "Tipi di avvisi",
    "description": "Le preferenze vengono salvate nel tuo account e applicate su tutti i dispositivi.",
    "deliveryHint": "E-mail e push dipendono dai canali abilitati dalla tua azienda. Per ricevere push, attiva anche gli avvisi su questo dispositivo. Le e-mail di accesso e sicurezza rimangono attive.",
    "saved": "Preferenze salvate.",
    "channels": {
      "email": "E-mail",
      "portal": "Portale",
      "push": "Push"
    },
    "categories": {
      "requests": {
        "title": "Richieste",
        "description": "Invio, ricezione e completamento della lettura."
      },
      "budgets": {
        "title": "Preventivi",
        "description": "Disponibilità, revisioni e cambiamenti di stato."
      },
      "reminders": {
        "title": "Promemoria",
        "description": "Promemoria per esaminare i preventivi in sospeso."
      },
      "incidents": {
        "title": "Problemi",
        "description": "Errori di lettura o preparazione del preventivo."
      },
      "updates": {
        "title": "Novità e altri avvisi",
        "description": "Comunicazioni generali e avvisi interni."
      }
    }
  },
  "twoFactor": {
    "title": "Verifica in due passaggi",
    "body": "Abbiamo inviato un codice di 6 cifre a",
    "codeLabel": "Codice di verifica",
    "submit": "Verifica e accedi",
    "notReceived": "Non l’hai ricevuto?",
    "resend": "Invia di nuovo",
    "resendIn": "Invia di nuovo ({{time}})",
    "expired": "La sessione di verifica è scaduta. Accedi di nuovo."
  },
  "adaltraProfile": {
    "roles": {
      "client": "Cliente",
      "commercial": "Commerciale",
      "manager": "Gestore",
      "admin": "Amministratore",
      "orders": "Ordini"
    },
    "protection": "Il tuo account, protetto",
    "protectionHint": "Verifica in due passaggi via email con un codice monouso.",
    "devicesHint": "I browser verificati possono essere ricordati per 30 giorni. Puoi rimuovere l’attendibilità di tutti.",
    "forgetDevices": "Dimentica dispositivi",
    "devicesRevoked": "L’attendibilità dei dispositivi è stata rimossa.",
    "passwordHint": "Aggiorna la password per proteggere il tuo account."
  },
  "stock": {
    "customerOrdersTitle": "Ordini clienti in attesa di consegna",
    "reportedDate": "Data comunicata: {{value}}",
    "customerOrdersCount": "Numero di ordini comunicato: {{value}}",
    "customerOrdersUnavailable": "Dettaglio ordini non disponibile",
    "customerOrdersEmpty": "L’elenco ricevuto non contiene ordini in sospeso.",
    "orderCustomer": "Cliente",
    "customerOrderNumber": "N. ordine cliente",
    "orderDate": "Data ordine",
    "deliveryDate": "Data consegna",
    "orderQuantity": "Quantità",
    "explanation": "Vedi la spiegazione ricevuta",
    "ordersAndCommitments": "Ordini e impegni",
    "pendingCustomers": "Consegne clienti in sospeso",
    "supplierOrders": "In ordine ai fornitori",
    "totalCommitted": "Totale impegnato",
    "remainingAfterRequest": "Residuo dopo l’operazione",
    "warehouses": "Stock fisico per magazzino",
    "warehouse": "Magazzino",
    "warehouseUnavailable": "Dettaglio per magazzino non disponibile",
    "supplyArrivals": "Arrivi previsti dai fornitori",
    "purchaseOrdersCount": "Ordini di acquisto: {{value}}",
    "expectedDate": "Data prevista",
    "purchaseOrder": "Ordine",
    "noArrivalDate": "Nessuna data prevista",
    "nextArrival": "Prossimo arrivo: {{value}}",
    "noIndicator": "Senza indicatore",
    "column": "Stock",
    "available": "Disponibile: {{value}}",
    "unknown": "Sconosciuto",
    "not_queried": "Stock non consultato",
    "unavailable": "Stock non disponibile",
    "not_applicable": "Non applicabile",
    "physical": "Fisico",
    "virtual": "Virtuale",
    "committed": "Totale impegnato",
    "checkedAt": "Consultato (ora spagnola): {{value}}",
    "requested": "Contesto della consultazione: {{value}} {{unit}}",
    "notComparable": "Il confronto con la quantità richiesta non è verificato.",
    "reason": "Motivo: {{value}}",
    "informational": "Solo a scopo informativo. Non riserva prodotti né garantisce la fornitura.",
    "details": "Vedi dettaglio stock. {{summary}}",
    "green": "Indicatore verde Atlas",
    "amber": "Indicatore ambra Atlas",
    "red": "Indicatore rosso Atlas",
    "article": "Articolo",
    "requestedColumn": "Quantità richiesta",
    "physicalVirtual": "Stock fisico / virtuale",
    "committedColumn": "Totale impegnato",
    "availableColumn": "Disponibilità effettiva",
    "indicatorColumn": "Indicatore",
    "dialogTitle": "Stock del prodotto",
    "minimumPurchase": "Quantità minima di acquisto: {{value}}",
    "minimumPurchasePackaging": "Quantità minima di acquisto: {{value}} (confezione {{packaging}})",
    "minimumPurchaseShort": "Min. {{value}}",
    "metric": "Voce",
    "checking": "Verifica dello stock…",
    "multipleOrders": "Più ordini: {{value}}",
    "yes": "Sì",
    "no": "No",
    "level": "Livello: {{value}}",
    "sharedProductTotal": "Il semaforo e lo stock residuo si riferiscono al totale del prodotto nell’elenco, senza ripartizione per riga.",
    "stale": "La consultazione è scaduta. Aggiorna lo stock per ottenere dati attuali.",
    "purchaseBasisUnknown": "Non è stato possibile verificare l’unità o la base di acquisto del prodotto.",
    "identityUnverified": "Non è stato possibile verificare il prodotto nel catalogo.",
    "sourceUnavailable": "Il servizio stock non è attualmente disponibile.",
    "reasonUnknown": "Atlas non ha potuto verificare uno stock aggiornato."
  },
  "stockSearch": {
    "productImage": "Immagine di {{reference}}",
    "imageUnavailable": "Immagine non disponibile",
    "hint": "Richieste o stock per codice / riferimento…",
    "label": "Cerca richieste o stock prodotti",
    "requests": "Cerca richieste con questo testo",
    "not_found": "Inserisci il codice o il riferimento completo del prodotto per consultarne lo stock.",
    "ambiguous": "Il riferimento corrisponde a più prodotti. Inserisci il codice completo.",
    "unavailable": "Impossibile consultare il prodotto. Riprova."
  },
  "closedOrder": {
    "confirmTitle": "Conferma ordine",
    "confirmSubtitle": "Controlla l’ordine definitivo prima di inviarlo ad Atlas. Non saranno aggiunte raccomandazioni e le quantità resteranno invariate.",
    "stockNotice": "Atlas segnala limiti di disponibilità per alcuni prodotti. Apri i relativi indicatori per i dettagli; puoi inviare l’ordine senza modificare articoli o quantità. Lo stock è informativo e non riserva materiale.",
    "send": "Invia ad Atlas",
    "dialogTitle": "Inviare questo ordine ad Atlas?",
    "dialogText": "L’elenco verificato sarà inviato senza aggiungere raccomandazioni. Controlla articoli e quantità prima di confermare.",
    "reviewSubtitle": "Controlla articoli e quantità dell’ordine prima di inviarlo ad Atlas.",
    "reviewedNote": "Questo ordine contiene soltanto gli articoli e le quantità dell’elenco verificato."
  },
  "productThumbnail": {
    "image": "Immagine di {{reference}}",
    "unavailable": "Immagine del prodotto non disponibile"
  },
  "customerOrder": {
    "action": "Vinto e passa a ordine",
    "dialogTitle": "Segnare come vinto e passare a ordine?",
    "dialogText": "Atlas invierà {{ref}} ad Ada-quote, segnerà il preventivo come VINTO e lo convertirà in ORDINE con il cliente, l’indirizzo, la data di consegna e il numero d’ordine del passo 1. Questa azione crea un ordine reale.",
    "retry": "Riprova",
    "confirmedDetail": "Ordine {{order}} · Preventivo {{quote}}",
    "providerError": "Risposta di Ada-quote: {{code}}",
    "state": {
      "requested": "Preparazione dell’ordine…",
      "submission_failed": "Impossibile inviare la richiesta",
      "pending_creation": "Creazione del preventivo in Ada-quote…",
      "sending": "Conversione in ordine…",
      "confirmed": "Preventivo vinto e convertito in ordine",
      "rejected": "Ada-quote ha rifiutato l’ordine",
      "uncertain": "Impossibile confermare l’ordine"
    },
    "refresh": "Aggiorna stato",
    "processingTitle": "Conversione in ordine",
    "processingText": "Atlas sta segnando il preventivo come vinto e creando l’ordine in Ada-quote.",
    "processingHint": "Puoi chiudere questa pagina: l’ordine prosegue.",
    "step": {
      "sending": "Invio della richiesta ad Atlas",
      "quote": "Preparazione del preventivo in Ada-quote",
      "won": "Preventivo segnato come vinto",
      "order": "Creazione dell’ordine",
      "pack": "Preparazione dell’ordine",
      "send": "Invio dell’ordine a MTR",
      "wait": "In attesa della conferma di MTR…"
    },
    "orderLabel": "Ordine",
    "quoteLabel": "Preventivo",
    "totalLabel": "Totale",
    "deliveryLabel": "Consegna",
    "customerOrderNumberLabel": "Ordine cliente",
    "stamp": "VINTO"
  },
  "maintenance": {
    "banner": "Atlas è in manutenzione. Puoi creare richieste e caricare documenti: premendo «Analizza» verranno messe in coda ed elaborate automaticamente al termine.",
    "until": "Previsto fino alle {{time}}.",
    "title": "Modalità manutenzione",
    "active": "Attiva",
    "inactive": "Disattivata",
    "description": "Con la modalità attiva, «Analizza» mette in coda le richieste e Atlas non avvia nuove letture; quelle in corso terminano. Disattivandola, la coda viene inviata automaticamente in ordine. Si disattiva da sola dopo 2 ore.",
    "since": "Attiva dalle {{time}}",
    "estimate": "prevista fino alle {{time}}",
    "expires": "si disattiva da sola alle {{time}}",
    "message": "Messaggio per gli utenti (facoltativo)",
    "minutes": "Durata stimata (min)",
    "processing_one": "{{count}} lettura in corso",
    "processing_other": "{{count}} letture in corso",
    "queued_one": "{{count}} richiesta in coda",
    "queued_other": "{{count}} richieste in coda",
    "turnOn": "Attiva manutenzione",
    "turnOff": "Disattiva e invia la coda",
    "queuedTitle": "Richiesta in coda",
    "queuedText": "Atlas è in manutenzione. La tua richiesta è salvata in coda e verrà inviata ad Atlas automaticamente appena terminata; ti avviseremo quando inizierà l’elaborazione. Puoi chiudere questa schermata.",
    "queuedHome": "Vai alla home"
  }
}
